<template>
  <v-container v-if="menu.selected" fluid>
    <Wait
      v-if="underProcessing()"
      :dialog="waitDialog"
      :generalExApplicationEx="generalExApplicationEx"
    />
    <Dialog
      v-if="loadedTransaction && staticDialog.show"
      :dialog="staticDialog"
      :generalExApplicationEx="generalExApplicationEx"
      @close-static-dialog="closeStaticDialog"
    >
    </Dialog>
    <SnackBar
      v-if="loadedTransaction && dialog.show"
      :dialog="dialog"
      @close-dialog="closeDialog"
    />
    <Confirm
      v-if="loadedTransaction && confirm.show"
      :confirm="confirm"
      :generalExApplicationEx="generalExApplicationEx"
      @close-confirm="closeConfirm"
    />
    <Trace
      v-if="okShowTrace()"
      :trace="trace"
      :input="this"
      @close-trace="closeTrace"
    />
    <Embed
      v-if="loadedTransaction"
      :embed="embed"
      :session="session"
      :environment="environment"
      :generalExApplicationEx="generalExApplicationEx"
      :applicationName="applicationName"
      :permission="menu.permission"
      :inputBreadCrumbs="breadCrumbs"
      :customLanguage="customLanguage"
      :custom="custom"
      @close-embed="closeEmbed"
      @close-all-embed="closeAllEmbed"
      @update-notification="updateNotification"
      @switch-language="switchLanguage"
      @user-interaction="userInteraction"
      ref="embedRef"
    />

    <v-snackbar
      v-if="alert()"
      v-model="showMessages"
      :timeout="messagesTime"
      absolute
      top
    >
      <v-alert :type="dialogType(alert().custom)" outlined>
        {{ alert().content }}
      </v-alert>
    </v-snackbar>

    <!-- Nav Bar -->
    <div v-if="showNavBar()">
      <v-toolbar
        dark
        :color="secondaryColor(generalExApplicationEx)"
        rounded
        short
      >
        <!-- Icon/Method -->
        <div v-if="!simpleHeader && formScreen(screen)">
          <v-icon v-if="transactionMethod == 'post'">mdi-plus-circle</v-icon>
          <v-icon v-if="transactionMethod == 'put'">mdi-pencil</v-icon>
          <v-icon v-if="transactionMethod == 'delete'">mdi-trash-can</v-icon>
        </div>

        <v-icon v-if="!simpleHeader && queryScreen(screen)"
          >mdi-database-search</v-icon
        >

        <v-icon v-if="!simpleHeader && calendarScreen(screen)"
          >mdi-calendar</v-icon
        >

        <v-btn icon @click="showTrace">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <!-- Title -->

        <v-toolbar-title class="text-subtitle-1">
          {{
            translatedConfig(
              generalExApplicationEx,
              customLanguage,
              screen.transaction,
              "mainTitle"
            )
          }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Flaps -->

        <v-toolbar v-if="flaps && flaps.count > 0" flat>
          <v-tabs
            center-active
            :value="flaps.selected"
            :background-color="secondaryColor(generalExApplicationEx)"
            fixed-tabs
          >
            <v-tab
              v-for="(flap, flapIndex) in flaps.items"
              :key="flapIndex"
              @click="selectFlap(flapIndex)"
              :disabled="!showFlap(flapIndex)"
              class="text-caption text-capitalize"
            >
              {{
                translatedConfig(
                  generalExApplicationEx,
                  customLanguage,
                  flap,
                  "caption"
                )
              }}
            </v-tab>
          </v-tabs>
        </v-toolbar>

        <v-spacer></v-spacer>

        <!-- Dynamic Filter -->

        <v-combobox
          v-if="queryFilterEnabled()"
          v-model="fieldFilter"
          filled
          hide-details
          rounded
          :id="'_fieldFilter'"
          :items="formFilterDynamicFields"
          :item-text="
            'formField.' +
            translatedKey(generalExApplicationEx, customLanguage, 'caption')
          "
          item-value="formField.fieldName"
          chips
          deletable-chips
          small-chips
          multiple
          @change="changeFieldFilter"
          @blur="blurFieldFilter"
        >
        </v-combobox>
        <v-tooltip v-if="queryFilterButtonEnabled()" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="showFieldFilterSelect" v-bind="attrs" v-on="on">
              <v-icon>mdi-filter-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ translatedText("queryFilterField") }}</span>
        </v-tooltip>

        <!-- Search -->

        <v-textarea
          v-if="queryScreen(screen) && queryLoaded && search != null"
          v-model="search"
          clearable
          filled
          hide-details
          rounded
          :label="translatedText('querySearchText')"
          :id="'_searchField'"
          rows="1"
          autocomplete="off"
        >
        </v-textarea>
        <v-tooltip v-if="visibleSearch()" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="showSearch" v-bind="attrs" v-on="on">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{ translatedText("querySearch") }}</span>
        </v-tooltip>

        <!-- Refresh -->

        <v-tooltip v-if="refreshButtonEnabled()" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="reloadQuery" v-bind="attrs" v-on="on">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>{{ translatedText("queryReload") }}</span>
        </v-tooltip>

        <!-- Language -->

        <v-btn v-if="allowLanguage" icon @click="switchLanguage">
          {{ invertedLanguage(generalExApplicationEx) }}
        </v-btn>

        <!-- File Download / Upload -->

        <div
          v-if="
            queryFileUploadScreen(screen) || queryFileDownloadScreen(screen)
          "
          class="text-center"
        >
          <v-menu
            v-model="fileMenu"
            :close-on-content-click="true"
            :nudge-width="100"
            offset-y
            dark
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-list flat>
                <v-tooltip
                  v-for="(fileAction, fileIndex) in queryFileActions()"
                  :key="fileIndex"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                      @click="fileAction.action"
                    >
                      <v-list-item-action>
                        <v-list-item-action-text no-action>
                          <v-icon large>{{ fileAction.icon1 }}</v-icon>
                          <v-icon small>{{ fileAction.icon2 }}</v-icon>
                        </v-list-item-action-text>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                  <span>{{ fileAction.caption }}</span>
                </v-tooltip>
                <div>
                  <v-file-input
                    v-show="false"
                    v-model="fileUpload"
                    ref="queryFileUploadRef"
                    :accept="'.xlsx'"
                    @change="changeQueryFileInputUpload"
                  />
                </div>
              </v-list>

              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>

        <!-- Actions -->

        <Actions
          :show="!this.simpleHeader && this.transactionMethod != 'delete'"
          :types="['general']"
          :method="transactionMethod"
          :actions="screen.actions"
          :generalExApplicationEx="generalExApplicationEx"
          :customLanguage="customLanguage"
          :data="allFormData()"
          @call-action="callAction"
        />
      </v-toolbar>
    </div>

    <div>
      <v-progress-linear
        v-if="loadedTransaction()"
        :indeterminate="secondaryUnderProcessing()"
        height="5"
      ></v-progress-linear>
      <v-alert
        v-if="alert()"
        :type="dialogType(alert().custom)"
        outlined
        dismissible
        dense
      >
        {{ alert().content }}
      </v-alert>
    </div>

    <div v-if="showLoadingSkeleton()">
      <v-skeleton-loader :type="skeletonContent()"></v-skeleton-loader>
    </div>

    <div v-else>
      <!-- Form -->
      <div
        v-if="
          formScreen(screen) ||
          formFilterScreen({
            screen,
            interactive: false,
            dynamic: formFilterDynamic,
          })
        "
      >
        <Form
          :generalExApplicationEx="generalExApplicationEx"
          :screen="screen"
          :formData="formData"
          :loadedTransaction="loadedTransaction()"
          :loading="loading"
          :submitting="submitting"
          :method="transactionMethod"
          :menu="menu"
          :changeHappened="changeHappened"
          :embed="embed"
          :renderKey="renderKey"
          :customLanguage="customLanguage"
          :formFilterDynamic="formFilterDynamic"
          :oneFieldFilter="oneFieldFilter"
          :environment="environment"
          :session="session"
          :underProcessing="underProcessing()"
          :secondaryUnderProcessing="secondaryUnderProcessing()"
          :dictionaryngList="dictionaryingList"
          :catalogingList="catalogingList"
          @handle-change="handleChange"
          @handle-browse-help="handleBrowseHelp"
          @handle-foreign-key="handleForeignKey"
          @submit-form="submitForm"
          @set-loading="setLoading"
          @call-action="callAction"
          @update-notification="updateNotification"
          ref="transactionForm"
        />
      </div>

      <!-- Query -->
      <div
        v-if="
          queryScreen(screen) &&
          (queryLoaded || queryFirstLoaded) &&
          !underProcessing()
        "
      >
        <Query
          :generalExApplicationEx="generalExApplicationEx"
          :screen="screen"
          :loadedTransaction="loadedTransaction"
          :queryPage="queryPage"
          :queryPages="queryPages"
          :allQueryData="allQueryData()"
          :menu="menu"
          :method="transactionMethod"
          :loading="loading"
          :querying="querying"
          :search="search"
          :queryLoaded="queryLoaded"
          :queryCount="queryCount"
          :querySort="querySort"
          :queryChecks="queryChecks"
          :queryLimit="queryLimit"
          :renderKey="renderKey"
          :customLanguage="customLanguage"
          :queryUploadLog="queryUploadLog"
          :queryRichData="queryRichData"
          :environment="environment"
          :queryChanged="changeQueryHappened"
          :custom="custom"
          :allFormData="allFormData()"
          :queryExtendedData="queryExtendedData"
          :dictionaryngList="dictionaryingList"
          :catalogingList="catalogingList"
          @call-action="callAction"
          @sort-column="sortColumn"
          @update-page-query="updatePageQuery"
          @update-page-limit="updatePageLimit"
          @query-check-change="queryCheckChange"
          @query-file-upload="queryFileUpload"
          @query-file-download="queryFileDownload"
          @show-query-upload-log="showQueryUploadLog"
          @handle-change-query="handleChangeQuery"
          ref="transactionQuery"
        />
      </div>

      <!-- Canvas -->
      <div v-if="canvasScreen(screen)">
        <Canvas
          :generalExApplicationEx="generalExApplicationEx"
          :screen="screen"
          :transactionName="transactionName"
          :canvasData="canvasData"
          :canvasActions="canvasActions"
          :inputData="inputData"
          :pagesName="pagesName()"
          :linesName="linesName()"
          :columnsName="columnsName()"
          :itemsName="itemsName()"
          :dictionaryngList="dictionaryingList"
          :catalogingList="catalogingList"
          @canvas-add-page="canvasAddPage"
          @canvas-add-line="canvasAddLine"
          @canvas-add-column="canvasAddColumn"
          @canvas-delete-page="canvasDeletePage"
          @canvas-delete-line="canvasDeleteLine"
          @canvas-delete-column="canvasDeleteColumn"
          @submit-canvas="submitCanvas"
          @call-action="callAction"
          ref="transactionCanvas"
        />
      </div>

      <!-- Canvas -->
      <div v-if="calendarScreen(screen) && calendarLoaded">
        <Calendar
          :generalExApplicationEx="generalExApplicationEx"
          :screen="screen"
          :formData="formData"
          :loadedTransaction="loadedTransaction"
          :loading="loading"
          :submitting="submitting"
          :method="transactionMethod"
          :menu="menu"
          :changeHappened="changeHappened"
          :embed="embed"
          :renderKey="renderKey"
          :customLanguage="customLanguage"
          :formFilterDynamic="formFilterDynamic"
          :oneFieldFilter="oneFieldFilter"
          :environment="environment"
          :session="session"
          :calendarEvents="calendarEvents"
          :dictionaryngList="dictionaryingList"
          :catalogingList="catalogingList"
          @handle-change="handleChange"
          @call-action="callAction"
          ref="transactionCalendar"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import Form from "./Form";
import Query from "./Query";
import SnackBar from "./../transaction/SnackBar";
import Dialog from "./../transaction/Dialog";
import Confirm from "./../transaction/Confirm";
import Embed from "./../transaction/Embed";
import Canvas from "./Canvas";
import moment from "moment";
import Wait from "./../transaction/Wait";
import Actions from "./Actions";
import Calendar from "./Calendar";
import Trace from "./Trace";
export default {
  name: "Transaction",
  props: [
    "applicationName",
    "menu",
    "session",
    "environment",
    "simpleHeader",
    "showSuccess",
    "showError",
    "inputData",
    "generalExApplicationEx",
    "outputType",
    "method",
    "flaps",
    "closeSubmit",
    "embedded",
    "inputBreadCrumbs",
    "customLanguage",
    "allowLanguage",
    "sourceActionType",
    "sourceAction",
    "embeddedField",
    "external",
    "custom",
  ],
  components: {
    SnackBar,
    Dialog,
    Confirm,
    Embed,
    Canvas,
    Form,
    Query,
    Wait,
    Actions,
    Calendar,
    Trace,
  },
  data() {
    return {
      // Transaction Handling
      transactionEx: {},
      screen: {
        transaction: {},
        formFieldsEx: [],
        queryFieldsEx: [],
        catalogsEx: [],
        dictionariesEx: [],
        actions: [],
        api: {},
        errorMessages: [],
        infoMessages: [],
        bucket: {},
        theme: {},
      },

      queryData: [],
      queryExtendedData: [],
      queryHeader: null,

      queryCount: null,
      queryPage: 1,
      queryLimit: 10,
      queryPages: 1,
      querySortField: null,
      querySortType: null,

      queryActions: [],
      queryLoaded: false,
      querySort: [],
      queryTimeout: null,
      queryFirstLoaded: false,

      queryChecks: [],

      queryUploadLog: [],

      queryRichData: {},

      queryError: false,

      queryApiResponse: {},

      calendarData: [],
      calendarEvents: [],
      calendarLoaded: false,

      calendarApiResponse: {},

      fileMenu: false,
      fileUpload: null,

      canvasData: {},
      canvasActions: {},

      // Internal
      dialog: {},
      confirm: {},
      trace: {},
      staticDialog: {},
      waitDialog: {},
      messages: [],
      showMessages: false,
      messagesTime: 3000,
      transactionName: "",
      transactionLoaded: false,
      actionMenu: false,
      embed: {},
      transactionMethod: null,

      submit: {
        todo: false,
        done: false,
        close: this.closeSubmit,
      },

      loading: false,
      submitting: false,
      querying: false,
      cataloging: false,
      dictionarying: false,

      catalogingList: [],
      dictionaryingList: [],

      breadCrumbs: [],

      // Data Treatment
      formData: {},
      formFilterDynamic: false,
      formFilterDynamicFields: [],
      fieldFilter: null,
      showFieldFilter: false,
      oneFieldFilter: false,

      // Search
      search: null,

      // Actions
      actionType: null,

      // Change
      changeHappened: false,
      changeQueryHappened: false,
      changesLog: [],

      // Display
      transactionSize: this.screenSize(),
      renderKey: 0,

      // FK
      foreignKeyArray: [],
      foreignKeyIndex: -1,
    };
  },
  methods: {
    // ---------------
    // MESSAGES HANDLING
    // ---------------

    updateNotification(data) {
      this.$emit("update-notification", data);
    },

    // ---------------
    // DIALOG HANDLING
    // ---------------

    showConfirm(input) {
      this.confirm = input;
      this.confirm.show = true;
    },

    closeConfirm(input) {
      let confirmSource = this.confirm;
      Object.keys(input).forEach((field) => {
        confirmSource[field] = input[field];
      });

      this.confirm = input;
      this.confirm.show = false;

      const okTodoDone = this.submit.todo == true && this.submit.done === false;
      const okTodo = this.submit.todo == true;
      const result = this.confirm.result;
      const type = confirmSource.type;
      const data = confirmSource.data;

      switch (type) {
        case "action": {
          if (result == "ok") {
            if (okTodoDone) {
              this.submit.todo = false;
              this.submit.done = true;
              this.bringData({
                transactionName: this.transactionName,
                confirmed: true,
              });
            }
          } else {
            if (okTodo) {
              this.exitTransaction({ show: false });
            }
          }
          break;
        }
        case "delete": {
          if (result == "ok") {
            if (okTodoDone) {
              this.submit.todo = false;
              this.submit.done = true;
              this.submitForm();
            }
          } else {
            if (okTodo) {
              this.exitTransaction({ show: false });
            }
          }
          break;
        }
        case "changes-form": {
          if (result == "yes") {
            if (okTodoDone) {
              this.submit.todo = false;
              this.submit.done = true;
              //this.submitTransaction();
              this.$refs.transactionForm.submitForm();
            }
          } else if (result == "no") {
            this.submit.todo = false;
            this.submit.done = true;
            /*
            if (type == "changes") {
              this.endCloseTransaction(data.data, data.embed);
            } else {
              this.endCloseAllTransaction(data.data, data.embed);
            }
            */
            this.endCloseTransaction(data.data, data.embed);
          }
          break;
        }
        case "changes-bulk-action": {
          if (result == "yes") {
            if (okTodoDone) {
              this.submit.todo = false;
              this.submit.done = false;
              this.callAction({
                action: confirmSource.data.action,
              });
              this.endCloseTransaction(data.data, data.embed);
            }
          } else if (result == "no") {
            this.submit.todo = false;
            this.submit.done = false;
            this.endCloseTransaction(data.data, data.embed);
          }
          break;
        }
      }
    },

    showDialog(data) {
      this.dialog = data;
      setTimeout(() => {
        this.closeDialog({ result: true });
      }, this.messagesTime);
      this.updateNotification(data);
    },

    closeDialog(data) {
      this.$emit("close-dialog", data);
      this.dialog = data;
      this.dialog.show = false;
    },

    // ---------------
    // EMBED HANDLING
    // ---------------

    showEmbed(data) {
      this.embed = data;
      this.embed.show = true;
      this.$refs.embedRef.callEmbed(this.embed);
    },
    closeEmbed(data, embed) {
      this.embed = data;
      this.embed.show = false;
      // Set values function
      const setValues = (inputData) => {
        let mapInputData = {};
        if (this.notBlank(embed.outputFields)) {
          embed.outputFields.split(",").forEach((outputField) => {
            const sourceField = outputField.includes(":")
              ? outputField.split(":")[0]
              : outputField;
            const targetField = outputField.includes(":")
              ? outputField.split(":")[1]
              : outputField;
            mapInputData[targetField] = inputData.data[sourceField];
          });
        } else {
          mapInputData = inputData.data;
        }
        const readonly =
          this.sourceAction && this.sourceAction.allow == "readonly";
        this.screen.formFieldsEx.forEach((formFieldEx, index) => {
          const fieldName = formFieldEx.formField.fieldName;
          const dictionaryName = formFieldEx.formField.dictionaryName;
          Object.keys(mapInputData).forEach((name) => {
            const dictionary = this.findDictionary(this.screen, dictionaryName);
            const raw = mapInputData[name];
            const value = !this.isCatalog(dictionary)
              ? raw
              : raw && typeof raw != "string"
              ? raw.toString()
              : raw;
            const okField = name == fieldName;
            if (okField) {
              const currentValue = this.getFieldValueByName(
                fieldName,
                this.screen.formFieldsEx,
                this.formData
              );
              const okReadonly = readonly ? !currentValue : true;
              if (okReadonly) {
                const ffeAutoSource =
                  this.screen.formFieldsEx[embed.coordinates.index];
                this.setFieldValueExt(
                  index,
                  value,
                  ffeAutoSource.formField.fieldName
                );
              }
            }
          });
        });
      };
      // Refresh query
      const outputAction = embed.sourceAction.outputAction;
      switch (outputAction) {
        default:
        case "refresh": {
          // Refresh query
          if (this.queryScreen(this.screen)) {
            this.parseQueryApi();
            this.parseRefreshLapse();
          }
          // Refresh canvas
          if (this.canvasScreen(this.screen)) {
            this.parseCanvasApi();
          }
          // Refresh calendar
          if (this.calendarScreen(this.screen)) {
            this.parseCalendarApi();
          }
          break;
        }
        case "close": {
          this.exitTransaction({ show: false });
          break;
        }
        case "selection": {
          if (data.result) {
            setValues(data);
          }
        }
      }

      // Handle foreign key result
      if (this.formScreen(this.screen)) {
        if (this.foreignKeyAction(data.actionType)) {
          if (data.result) {
            setValues(data);
          } else {
            let keyCaption = "";
            this.screen.formFieldsEx.forEach((ffe) => {
              Object.keys(embed.inputData).forEach((name) => {
                if (ffe.formField.fieldName == name) {
                  keyCaption +=
                    " " +
                    this.translatedConfig(
                      this.generalExApplicationEx,
                      this.customLanguage,
                      ffe.formField,
                      "caption"
                    ) +
                    ": " +
                    embed.inputData[name];
                }
              });
            });
            this.showDialog({
              custom: "error",
              content:
                keyCaption.trim() + " " + this.errorMessage("foreignKeyError"),
            });
            this.setFieldValueExt(embed.coordinates.index, null);
          }
          if (this.foreignKeyArray.length > 0 && this.foreignKeyIndex >= 0) {
            this.foreignKeyIndex++;
            if (this.foreignKeyIndex < this.foreignKeyArray.length) {
              this.handleForeignKey();
            } else {
              this.foreignKeyArray = [];
              this.foreignKeyIndex = -1;
            }
          }
        }
      }
    },

    closeAllEmbed() {
      this.closeEmbed({ show: false });
      this.$emit("exit-all-transaction");
    },

    // ---------------
    // GET AND PARSING
    // ---------------

    addCatalog(catalogEx) {
      const found = this.findCatalogExByKey(this.screen, catalogEx.key);
      if (!found) {
        this.screen.catalogsEx.push(catalogEx);
      }
    },

    afterLoadCatalog(type, index, catalogEx) {
      if (type != "query") {
        this.handleFirstElementCatalog(index, catalogEx.items);
        this.handleOtherExtendedCatalog(index, catalogEx.items);
      }
      this.updateAndRender();
    },

    addDictionary(dictionaryEx) {
      const found = this.findDictionaryEx(
        this.screen,
        dictionaryEx.dictionary.name
      );
      if (!found) {
        this.screen.dictionariesEx.push(dictionaryEx);
      }
    },

    allInputData() {
      return this.inputData ? this.inputData : {};
    },

    getField(getId) {
      return this.formData[this.getFieldId(getId)];
    },

    allFormData() {
      let data = {};

      // Handling multi-use fields
      let repeated = [];
      this.screen.formFieldsEx.forEach((ffe1, i) => {
        this.screen.formFieldsEx.forEach((ffe2, j) => {
          if (
            !repeated.includes(ffe1.formField.fieldName) &&
            i != j &&
            ffe1.formField.fieldName == ffe2.formField.fieldName
          ) {
            repeated.push(ffe1.formField.fieldName);
          }
        });
      });

      const assignValue = (key, val) => {
        if (this.formScreen(this.screen) && key.includes(".")) {
          if (!val) return;
          const keys = key.split(".");
          const firstKey = keys.shift();
          let map = keys.reduceRight((obj, elem) => ({ [elem]: obj }), val);
          data[firstKey] = { ...(data[firstKey] ?? {}), ...map };
        } else {
          data[key] = val;
        }
      };

      // Assign form fields data
      this.screen.formFieldsEx.forEach((ffe, i) => {
        if (repeated.includes(ffe.formField.fieldName)) {
          if (this.getField(i).value != null) {
            assignValue(this.getField(i).name, this.getField(i).value);
          }
        } else {
          assignValue(this.getField(i).name, this.getField(i).value);
        }
      });

      return data;
    },

    parseDataForQuery() {
      return this.screen.formFieldsEx && this.screen.formFieldsEx.length > 0
        ? this.allFormData()
        : this.allInputData();
    },

    solveQueryFieldFormula(field, data, key, base) {
      const formula = field[key + "Formula"];
      if (formula) {
        const result = eval(formula, data);
        return result;
      } else {
        return base;
      }
    },

    promiseLoadDictionaries(dictionariesArray) {
      const fetchDictionary = (dictionaryData) => {
        this.addDictionaryingList(dictionaryData);
        return new Promise((resolve, reject) => {
          this.apiLoadDictionary({
            path: { dictionaryName: dictionaryData.dictionaryName },
          })
            .then((dic) => {
              this.deleteDictionaryingList(dictionaryData.dictionaryName);
              resolve(dic);
            })
            .catch((err) => {
              reject(err);
            });
        });
      };
      const promisesArray = dictionariesArray.map(fetchDictionary);
      return Promise.all(promisesArray);
    },

    promiseLoadCatalogs(catalogsArray) {
      const fetchCatalog = (catalogData) => {
        this.addCatalogingList(catalogData);
        return new Promise((resolve, reject) => {
          this.apiLoadCatalog({
            path: { dictionaryName: catalogData.dictionaryName },
            body: catalogData.inputData,
          })
            .then((cat) => {
              this.deleteCatalogingList(catalogData.key);
              resolve(cat);
            })
            .catch((err) => {
              reject(err);
            });
        });
      };
      const promisesArray = catalogsArray.map(fetchCatalog);
      return Promise.all(promisesArray);
    },

    parseDynamicContentProcess(
      fieldIndex,
      type,
      dictionaryName,
      inputData,
      arrays
    ) {
      let dictionariesArray = arrays.dictionariesArray;
      let catalogsArray = arrays.catalogsArray;

      // Evaluate Dictionary
      let dictionaryEx = this.findDictionaryEx(this.screen, dictionaryName);
      if (!dictionaryEx) {
        const findDictionaryArray = dictionariesArray.find((d) => {
          return d.dictionaryName == dictionaryName;
        });
        if (!findDictionaryArray) {
          dictionariesArray.push({
            dictionaryName,
            inputData,
            index: fieldIndex,
            query: type == "query",
          });
        }
      }

      // Evaluate Catalog
      const catalogEx = this.findCatalogEx(
        this.screen,
        dictionaryName,
        inputData
      );
      if (!catalogEx) {
        const key = this.getCatalogKey(dictionaryName, inputData);
        const findCatalogArray = catalogsArray.find((c) => {
          return c.key == key;
        });
        if (!findCatalogArray) {
          catalogsArray.push({
            key,
            dictionaryName,
            inputData,
            index: fieldIndex,
            query: type == "query",
            type,
          });
        }
      }

      return { dictionariesArray, catalogsArray };
    },

    parseDynamicContentDictionaries(type, arrays, index, forceRender) {
      this.dictionarying = true;
      this.promiseLoadDictionaries(arrays.dictionariesArray)
        .then((dictionariesArrayRes) => {
          this.dictionarying = false;
          dictionariesArrayRes.forEach((dictionaryRes, dictionaryIndex) => {
            if (this.getTranApiSuccess(dictionaryRes.data)) {
              const dictionaryEx = dictionaryRes.data;
              const dictionary = dictionaryEx.dictionary;
              const dictionaryName = dictionary.name;
              this.deleteDictionaryingList(dictionaryName);
              this.addDictionary(dictionaryEx);
              const dictionaryInput = arrays.dictionariesArray[dictionaryIndex];
              if (!dictionaryInput.query) {
                this.screen.formFieldsEx[
                  dictionaryInput.index
                ].formField.dictionaryName = dictionaryName;
              }

              this.updateAndRender();
            } else {
              this.dictionarying = false;

              this.showDialog({
                custom: "error",
                content: this.getTranApiMessages(dictionaryRes.data, true),
              });
            }
          });

          this.parseDynamicContent(type, index, forceRender, true);
        })
        .catch((e) => {
          this.dictionarying = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage("dictionaryError", e),
          });
          this.updateAndRender();
        });
    },

    parseDynamicContentCatalogs(arrays, forceRender) {
      let catalogsDefArray = arrays.catalogsArray.filter((catalog) => {
        const dictionary = this.findDictionary(
          this.screen,
          catalog.dictionaryName
        );
        return dictionary && this.isCatalog(dictionary);
      });

      if (catalogsDefArray.length > 0) {
        this.cataloging = true;
        this.promiseLoadCatalogs(catalogsDefArray)
          .then((catalogsArrayRes) => {
            this.cataloging = false;
            catalogsArrayRes.forEach((catalogRes, catalogResIndex) => {
              const catalogInput = catalogsDefArray[catalogResIndex];
              const catalogEx = catalogRes.data;
              if (this.getTranApiSuccess(catalogEx)) {
                this.addCatalog(catalogEx);
                this.afterLoadCatalog(
                  catalogInput.type,
                  catalogInput.index,
                  catalogEx
                );
              } else {
                this.cataloging = false;
                this.showDialog({
                  custom: "error",
                  content: this.errorMessage(
                    "catalogError",
                    "[" +
                      catalogEx.key +
                      "] " +
                      this.getTranApiMessages(catalogEx, true)
                  ),
                });
              }
            });
            this.updateAndRender();
          })
          .catch((e) => {
            this.cataloging = false;
            this.showDialog({
              custom: "error",
              content: this.errorMessage("catalogError", e),
            });
            this.updateAndRender();
          });
      } else if (forceRender) {
        this.updateAndRender();
      }
    },

    parseDynamicContent(type, index, forceRender, justCatalogs, line) {
      let arrays = {
        dictionariesArray: [],
        catalogsArray: [],
      };

      if (["both", "form"].includes(type)) {
        this.screen.formFieldsEx.forEach((ffe, fieldIndex) => {
          const okIndex = index == null || index == fieldIndex;
          if (okIndex) {
            const data = this.allFormData();
            const inputData = this.buildInputData(ffe.formField.inputFields);
            const currentDictionaryName = ffe.formField.dictionaryName;
            const dictionaryName = this.solveQueryFieldFormula(
              ffe.formField,
              data,
              "dictionary",
              currentDictionaryName
            );

            arrays = this.parseDynamicContentProcess(
              fieldIndex,
              "form",
              dictionaryName,
              inputData,
              arrays
            );
          }
        });
      }

      if (["both", "query"].includes(type)) {
        this.allQueryData().forEach((record, recordIndex) => {
          const okRecordIndex = line == null || line == recordIndex;
          if (okRecordIndex) {
            this.screen.queryFieldsEx.forEach((qfe, fieldIndex) => {
              const okIndex = index == null || index == fieldIndex;
              if (okIndex) {
                const data = record;
                const inputData = this.basicBuildInputData(
                  qfe.queryField.inputFields,
                  data
                );
                const currentDictionaryName = qfe.queryField.dictionaryName;
                const dictionaryName = this.solveQueryFieldFormula(
                  qfe.queryField,
                  data,
                  "dictionary",
                  currentDictionaryName
                );
                arrays = this.parseDynamicContentProcess(
                  fieldIndex,
                  "query",
                  dictionaryName,
                  inputData,
                  arrays
                );
              }
            });
          }
        });
      }

      this.cataloging = false;
      this.dictionarying = false;

      if (
        arrays.dictionariesArray.length > 0 ||
        arrays.catalogsArray.length > 0
      ) {
        if (arrays.dictionariesArray.length > 0 && !justCatalogs) {
          this.parseDynamicContentDictionaries(
            type,
            arrays,
            index,
            forceRender
          );
        } else if (arrays.catalogsArray.length > 0) {
          this.parseDynamicContentCatalogs(arrays, forceRender);
        }
      } else if (forceRender) {
        this.updateAndRender();
      }

      this.parseDynamicFiles(type);
    },

    parseDynamicFiles(type) {
      if (this.screen.bucket.access == "PRIVATE") {
        try {
          if (["both", "form"].includes(type)) {
            this.screen.formFieldsEx.forEach((ffe, ffeIndex) => {
              const formField = ffe.formField;
              const fieldName = formField.fieldName;
              const dictionary = this.findDictionary(
                this.screen,
                formField.dictionaryName
              );
              const field = this.formData[this.getFieldId(ffeIndex)];
              const { value, url } = field;
              const okLoad =
                this.dynamicFileFieldValue(
                  this.contextBucket(this.screen),
                  dictionary,
                  value
                ) &&
                (!url || !this.validateUrl(url));
              if (okLoad) {
                this.apiDoQueryFile({
                  path: {
                    transactionName: this.transactionName,
                  },
                  body: {
                    fieldName: fieldName,
                    inputData: this.buildInputData(formField.inputFields),
                    type: value.includes(".") ? value.split(".").pop() : null,
                    name: value,
                  },
                })
                  .then((queryFileRes) => {
                    const apiResponse = queryFileRes.data;
                    if (this.getApiSuccess(apiResponse)) {
                      this.setFieldUrlExt(ffeIndex, apiResponse.data.url);
                      this.updateAndRender();
                    } else {
                      this.showDialog({
                        custom: "error",
                        content: this.errorMessage("queryFileError"),
                      });
                    }
                  })
                  .catch((queryFileError) => {
                    this.querying = false;
                    this.showDialog({
                      custom: "error",
                      content: this.errorMessage(
                        "queryFileError",
                        queryFileError
                      ),
                    });
                  });
              }
            });
          }
        } catch (e) {
          this.showDialog({
            custom: "error",
            content: this.errorMessage(
              "dynamicFilesError",
              "[" + type + "] " + e
            ),
          });
        }

        try {
          if (["both", "query"].includes(type)) {
            this.screen.queryFieldsEx.forEach((qfe) => {
              const queryField = qfe.queryField;
              const fieldName = queryField.fieldName;
              const dictionary = this.findDictionary(
                this.screen,
                queryField.dictionaryName
              );
              this.queryData.forEach((record, recordIndex) => {
                const extended = this.queryExtendedData.find(
                  (qed) => qed.index == recordIndex
                );
                const url = extended ? extended.data[fieldName].url : null;
                const value = record[fieldName];
                const okLoad =
                  this.dynamicFileFieldValue(
                    this.contextBucket(this.screen),
                    dictionary,
                    value
                  ) &&
                  (!url || !this.validateUrl(url));
                if (okLoad) {
                  this.apiDoQueryFile({
                    path: {
                      transactionName: this.transactionName,
                    },
                    body: {
                      fieldName: fieldName,
                      inputData: this.basicBuildInputData(
                        queryField.inputFields,
                        record
                      ),
                      type: value.includes(".") ? value.split(".").pop() : null,
                      name: value,
                    },
                  })
                    .then((queryFileRes) => {
                      const apiResponse = queryFileRes.data;
                      if (this.getApiSuccess(apiResponse)) {
                        this.queryExtendedData[recordIndex].data[
                          fieldName
                        ].url = apiResponse.data.url;
                        this.updateAndRender();
                      } else {
                        this.showDialog({
                          custom: "error",
                          content: this.errorMessage("queryFileError"),
                        });
                      }
                    })
                    .catch((queryFileError) => {
                      this.querying = false;
                      this.showDialog({
                        custom: "error",
                        content: this.errorMessage(
                          "queryFileError",
                          queryFileError
                        ),
                      });
                    });
                }
              });
            });
          }
        } catch (e) {
          this.showDialog({
            custom: "error",
            content: this.errorMessage(
              "dynamicFilesError",
              "[" + type + "] " + e
            ),
          });
        }
      }
    },

    getQueryParams(fileType) {
      return {
        sort:
          this.querySortType && this.querySortField
            ? (this.querySortType !== "asc" ? "-" : "") + this.querySortField
            : null,
        page: this.queryPage ? this.queryPage : 1,
        limit: this.queryLimit ? this.queryLimit : 10,
        offset: this.queryLimit * (this.queryPage - 1),
        fileType,
      };
    },

    parseQueryApi(notLoading) {
      if (this.queryApiScreen()) {
        const body = this.parseDataForQuery();

        this.querying = true && !notLoading;

        this.changeQueryHappened = false;

        this.apiLoadQuery({
          path: { transactionName: this.transactionName },
          params: this.getQueryParams(),
          body,
        })
          .then((queryRes) => {
            this.apiExceptions(queryRes.data, this.generalExApplicationEx);
            this.queryApiResponse = queryRes.data;
            if (this.getApiSuccess(queryRes.data)) {
              if (this.richQuery(this.screen)) {
                this.queryData = this.getApiData(queryRes.data).data;
                this.queryCount = this.getApiData(queryRes.data).count;
                this.queryHeader = this.getApiData(queryRes.data).header;
              } else {
                this.queryData = this.getApiData(queryRes.data);
                this.queryCount = this.allQueryData().length;
              }

              this.setPageQueryData();
              this.setQueryData();
              this.setQueryExtendedData();
              this.setQueryHeader();
              this.setQueryFormulas();
              this.queryLoaded = true;
              this.queryError = false;
              this.querying = false;
              this.queryFirstLoaded = this.queryFirstLoaded
                ? this.queryFirstLoaded
                : true;

              this.$emit("after-parse-query-api", {
                queryData: this.queryData,
                queryCount: this.queryCount,
                queryLoaded: this.queryLoaded,
              });

              this.parseDynamicContent("query", null);
            } else {
              this.queryError = true;
              this.querying = false;
              this.showDialog({
                custom: "error",
                content: this.errorMessage(
                  "queryError",
                  this.getApiMessages(queryRes.data, true)
                ),
              });
              this.exitTransaction({ show: false });
            }
          })
          .catch((queryError) => {
            this.queryError = true;
            this.querying = false;
            this.showDialog({
              custom: "error",
              content: this.errorMessage("queryError", queryError),
            });
          });
      }
    },

    sortQuery(fieldName) {
      if (this.queryScreen(this.screen) && this.queryLoaded) {
        this.queryData.sort(function (a, b) {
          return a[fieldName] > b[fieldName];
        });
      }
    },

    parseCanvasApi() {
      if (this.canvasApiScreen()) {
        const data = this.allInputData();
        this.querying = true;
        this.apiLoadQuery(
          this.applicationName,
          this.transactionName,
          this.queryPage,
          this.queryLimit,
          this.querySortField,
          this.querySortType,
          data,
          this.queryMode()
        )
          .then((canvasRes) => {
            this.apiExceptions(canvasRes.data, this.generalExApplicationEx);
            //this.calendarApiResponse = calendarRes.data;
            if (this.getApiSuccess(canvasRes.data)) {
              this.canvasData = this.getApiData(canvasRes.data);
              /*
              this.canvasData[0].forEach((page, pageIndex) => {
                page[this.linesName()].forEach((line, lineIndex) => {
                  line[this.columnsName()].forEach((column, columnIndex) => {
                    column[this.itemsName()].forEach((item, itemIndex) => {
                      this.canvasActions[
                        "P" +
                          pageIndex +
                          "L" +
                          lineIndex +
                          "C" +
                          columnIndex +
                          "I" +
                          itemIndex
                      ] = false;
                    });
                  });
                });
              });
              */

              //this.calendarLoaded = true;
              this.queryFirstLoaded = this.queryFirstLoaded
                ? this.queryFirstLoaded
                : true;
              this.querying = false;
            } else {
              //this.calendarLoaded = false;
              this.querying = false;
              this.showDialog({
                custom: "error",
                content: this.errorMessage(
                  "queryError",
                  this.getApiMessages(canvasRes.data, true)
                ),
              });
              this.exitTransaction({ show: false });
            }

            /*
            this.querying = false;
            this.canvasData = canvasRes.data;
            this.canvasData[this.pagesName()].forEach((page, pageIndex) => {
              page[this.linesName()].forEach((line, lineIndex) => {
                line[this.columnsName()].forEach((column, columnIndex) => {
                  column[this.itemsName()].forEach((item, itemIndex) => {
                    this.canvasActions[
                      "P" +
                        pageIndex +
                        "L" +
                        lineIndex +
                        "C" +
                        columnIndex +
                        "I" +
                        itemIndex
                    ] = false;
                  });
                });
              });
            });
            */
          })
          .catch((canvasError) => {
            this.querying = false;
            this.showDialog({
              custom: "error",
              content: this.errorMessage("canvasError", canvasError),
            });
          });
      }
    },

    parseCalendarEvents() {
      const events = this.calendarData.map((sourceEvent) => {
        let event = {};
        Object.keys(sourceEvent).forEach((field) => {
          const qfe = this.screen.queryFieldsEx.find(
            (qfe) => qfe.queryField.fieldName == field
          );
          if (qfe) {
            const qf = qfe.queryField;
            const targetName = qf.alias ? qf.alias : qf.fieldName;
            const sourceValue = sourceEvent[qf.fieldName];
            event[targetName] = ["start", "end"].includes(targetName)
              ? moment(sourceValue, "YYYY-MM-DD").toDate()
              : sourceValue;
          }
        });

        //const color = this.querySpreadColor(this.screen, sourceEvent);
        //event.color = color ? color : "blue";

        const spreadColor = this.querySpreadColor(this.screen, sourceEvent);
        const iconColor = this.queryIconColor(this.screen, sourceEvent);

        event.color = spreadColor
          ? spreadColor
          : iconColor
          ? iconColor
          : "gray";

        event.data = sourceEvent;

        return event;
      });

      this.calendarEvents = events;
      this.updateAndRender();
    },

    parseCalendarApi() {
      if (this.calendarApiScreen()) {
        const data = this.parseDataForQuery();

        this.querying = true;

        this.apiLoadQuery(
          this.applicationName,
          this.transactionName,
          null,
          null,
          null,
          null,
          data,
          this.queryMode()
        )
          .then((calendarRes) => {
            this.apiExceptions(calendarRes.data, this.generalExApplicationEx);
            this.calendarApiResponse = calendarRes.data;
            if (this.getApiSuccess(calendarRes.data)) {
              this.calendarData = this.getApiData(calendarRes.data);
              this.parseCalendarEvents();
              this.calendarLoaded = true;
              this.queryFirstLoaded = this.queryFirstLoaded
                ? this.queryFirstLoaded
                : true;
              this.querying = false;
            } else {
              this.calendarLoaded = false;
              this.querying = false;
              this.showDialog({
                custom: "error",
                content: this.errorMessage(
                  "queryError",
                  this.getApiMessages(calendarRes.data, true)
                ),
              });
              this.exitTransaction({ show: false });
            }
          })
          .catch((calendarError) => {
            this.calendarLoaded = false;
            this.querying = false;
            this.showDialog({
              custom: "error",
              content: this.errorMessage("queryError", calendarError),
            });
          });
      }
    },

    fieldRules(formFieldEx) {
      let rules = [];
      let formField = formFieldEx.formField;

      const dictionary = this.findDictionary(
        this.screen,
        formFieldEx.formField.dictionaryName
      );
      const dataType = dictionary.dataType;
      const checkField = this.checkField(dictionary);
      const comboField = this.comboField(dictionary);
      const dateField = this.dateField(dictionary);
      const fieldName = formField.fieldName;

      // Access rules
      let access = this.getFieldAccess(
        formField.access,
        this.menu.permission,
        this.transactionMethod
      );
      switch (access) {
        case "required": {
          if (this.comboTagField(dictionary)) {
            let rule = (v) =>
              (v && Array.isArray(v) && v.length > 0) ||
              this.translatedText("requiredFieldText");
            rules.push(rule);
          } else {
            let rule = (v) => !!v || this.translatedText("requiredFieldText");
            rules.push(rule);
          }
          break;
        }
      }
      // Content rules
      const confirm = formField.confirmField;
      if (confirm) {
        let rule = (v) =>
          v ===
            this.getFieldValueByName(
              confirm,
              this.screen.formFieldsEx,
              this.formData
            ) || this.translatedText("invalidFieldText");
        rules.push(rule);
      }

      // Check rules
      if (this.checkField(dictionary) && access == "required") {
        let rule = (v) => v === true || this.translatedText("invalidFieldText");
        rules.push(rule);
      }

      // Min Max Rules Integer
      const integer = this.fieldInteger(dataType);
      if (integer && !checkField && !comboField && !dateField) {
        const maximum = formField.max;
        if (maximum && maximum > 0) {
          let rule = (v) => v <= maximum || "Max: " + maximum;
          rules.push(rule);
        }
      }

      if (integer && !checkField && !comboField && !dateField) {
        const minimum = formField.min;
        if (minimum != null) {
          let rule = (v) => v >= minimum || "Min: " + minimum;
          rules.push(rule);
        }
      }

      // Min Max Rules Real
      const real = this.fieldReal(dataType);
      if (real && !checkField && !comboField && !dateField) {
        const maximum = parseFloat(formField.max);
        if (formField.max && maximum > 0) {
          let rule = (v) => parseFloat(v) <= maximum || "Max: " + maximum;
          rules.push(rule);
        }
      }

      if (real && !checkField && !comboField && !dateField) {
        const minimum = parseFloat(formField.min);
        if (formField.min != null) {
          let rule = (v) => parseFloat(v) >= minimum || "Min: " + minimum;
          rules.push(rule);
        }
      }

      // Lenghts
      const text = this.textField(dictionary) || this.passwordField(dictionary);
      if (text && !integer && !real) {
        //const maxLength = formField.length ? formField.length : dictionary.length;
        const minLength = formField.secLength
          ? formField.secLength
          : dictionary.secLength;
        if (minLength) {
          let rule = (v) => {
            return (
              (access == "required"
                ? v && v.length >= minLength
                : access == "optional"
                ? v || v.length >= minLength
                : true) ||
              this.translatedText("largeText") + " Min: " + minLength
            );
          };
          rules.push(rule);
        }
      }

      // Validation Formula
      const validationFormula = formField.validationFormula;
      if (validationFormula) {
        let rule = (v) => {
          const global = {
            now: moment().format("llll"),
            nowFormatted: moment().format("YYYY-MM-DD"),
            method: this.transactionMethod,
            moment: moment,
            applicationName: this.applicationName,
            language: this.customLanguage,
          };
          let data = this.allFormData();
          data[fieldName] = v;
          return (
            eval(validationFormula, data, global) ||
            this.translatedText("invalidFieldText")
          );
        };
        rules.push(rule);
      }
      return rules;
    },

    parseFormData(input) {
      const thisValue =
        input.type != "boolean"
          ? input.value
          : this.notBlank(input.value)
          ? input.value == "true"
          : input.value == null
          ? null
          : false;
      const thisUrl = this.dynamicFileFieldValue(
        this.contextBucket(this.screen),
        input.dictionary,
        thisValue
      )
        ? null
        : this.fileInputField(input.dictionary)
        ? thisValue
        : null;
      this.formData[this.getFieldId(input.id)] = {
        name: input.name,
        type: input.type,
        value: thisValue,
        rules: input.rules,
        index: input.id,
        access: input.access,
        customStyle: input.customStyle,
        file: null,
        selected: false,
        progress: this.notBlank(thisValue) ? 100 : 0,
        uploaded: false,
        accessFormula: input.accessFormula,
        valueFormula: input.valueFormula,
        captionFormula: input.captionFormula,
        captionLanFormula: input.captionLanFormula,
        prefixFormula: input.prefixFormula,
        suffixFormula: input.suffixFormula,
        dictionaryFormula: input.dictionaryFormula,
        customStyleFormula: input.customStyleFormula,
        initialValue: thisValue,
        initialAccess: input.access,
        loading: input.loading,
        dataType: input.dataType,
        filterChange: input.filterChange,
        url: thisUrl,
      };
    },

    parseAllFormData() {
      this.formData = {};
      this.screen.formFieldsEx.forEach((formFieldEx, i) => {
        let formField = formFieldEx.formField;

        let dictionary = this.findDictionary(
          this.screen,
          formFieldEx.formField.dictionaryName
        );

        let access = this.actualFieldAccess(
          this.getFieldAccess(
            formField.access,
            this.menu.permission,
            this.transactionMethod
          )
        );

        this.screen.formFieldsEx[i].formField.access = access;

        let rules = this.fieldRules(formFieldEx);
        this.parseFormData({
          id: i,
          name: formField.fieldName,
          type: this.getValueType(dictionary),
          value: formField.defaultValue,
          access,
          rules,
          customStyle: formField.customStyle,
          accessFormula: formField.accessFormula,
          valueFormula: formField.valueFormula,
          captionFormula: formField.captionFormula,
          captionLanFormula: formField.captionLanFormula,
          prefixFormula: formField.prefixFormula,
          suffixFormula: formField.suffixFormula,
          dictionaryFormula: formField.dictionaryFormula,
          customStyleFormula: formField.customStyleFormula,
          loading: false,
          dataType: dictionary.dataType,
          filterChange: this.fieldFilterChange(dictionary),
          dictionary,
        });
      });
    },

    parseRichQueryData(getId, getName, getLoading) {
      this.queryRichData[this.getFieldId(getId)] = {
        name: getName,
        loading: getLoading,
      };
    },

    parseAllQueryData() {
      if (this.pageableQuery(this.screen)) {
        this.queryLimit = this.screen.transaction.pageLimit;
        const defaultSortQfe = this.screen.queryFieldsEx.find(
          (qfe) => qfe.queryField.defaultSort
        );
        if (defaultSortQfe) {
          this.querySortType = defaultSortQfe.queryField.defaultSort;
          this.querySortField = defaultSortQfe.queryField.fieldName;
        }
      }
    },

    parseAllQueryRichData() {
      this.queryRichData = {};
      this.screen.queryFieldsEx.forEach((queryFieldEx, i) => {
        let queryField = queryFieldEx.queryField;
        let loading = false;
        this.parseRichQueryData(i, queryField.fieldName, loading);
      });
    },

    parseForeignKeys() {
      this.$mount();
      this.screen.formFieldsEx.forEach((formFieldEx, index) => {
        if (this.notBlank(formFieldEx.formField.foreignKey)) {
          const id = this.getFieldId(index);
          const value = this.formData[this.getFieldId(index)].value;
          if (this.transactionMethod != "post" || value) {
            const transactionName = formFieldEx.formField.foreignKey;
            const data = { index, id, value, transactionName };
            this.foreignKeyArray.push(data);
          }
        }
      });
      if (this.foreignKeyArray.length > 0) {
        this.foreignKeyIndex = 0;
        this.handleForeignKey();
      }
    },

    parseFormulas() {
      this.handleDynamicFormulas(
        null,
        ["access", "value", "caption", "captionLan", "prefix", "suffix"],
        true
      );
    },

    parseMethod() {
      const isDelete =
        this.transactionMethod == "delete" &&
        !this.backTransaction(this.screen);

      if (isDelete) {
        if (!this.confirm.result) {
          this.submit.todo = true;
          this.showConfirm({
            content: this.translatedText("confirmDelete"),
            type: "delete",
          });
        }
      }
    },

    parseRefreshLapse() {
      if (this.transactionLoaded) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        if (this.screen.transaction.refreshLapse) {
          this.queryTimeout = setTimeout(() => {
            this.messages = [];
            this.parseQueryApi(true);
            this.parseRefreshLapse();
          }, this.screen.transaction.refreshLapse);
        }
      }
    },

    parseBreadCrumbs() {
      const crumb = {
        text: this.translatedConfig(
          this.generalExApplicationEx,
          this.customLanguage,
          this.screen.transaction,
          "mainTitle"
        ),
      };
      this.breadCrumbs = [crumb];
      if (this.inputBreadCrumbs && this.inputBreadCrumbs.length > 0) {
        this.breadCrumbs = this.inputBreadCrumbs.concat([crumb]);
      }
    },

    parseFilterDynamic() {
      this.formFilterDynamic = this.formFilterOptionalScreen(this.screen);
      if (this.formFilterDynamic) {
        this.screen.formFieldsEx.forEach((ffe, index) => {
          const formField = ffe.formField;
          if (this.optionalField(formField.access)) {
            let ffdf = ffe;
            ffdf.oriIndex = index;

            // Default caption
            ffdf.formField.captionLan = !ffdf.formField.captionLan
              ? ffdf.formField.caption
              : ffdf.formField.captionLan;

            // Default title for sorting
            ffdf.title = this.translatedConfig(
              this.generalExApplicationEx,
              this.customLanguage,
              ffdf.formField,
              "caption"
            );

            this.formFilterDynamicFields.push(ffdf);

            if (this.specialForcedField(formField)) {
              if (!this.fieldFilter) {
                this.fieldFilter = [];
              }
              this.fieldFilter.push(ffdf);
              this.oneFieldFilter = true;
            } else {
              // Put all hidden and self line
              this.screen.formFieldsEx[index].formField.access = "hidden";
              this.screen.formFieldsEx[index].formField.startRow = true;
              this.screen.formFieldsEx[index].formField.endRow = true;
            }
          }
        });
        if (this.formFilterDynamicFields.length > 0) {
          this.formFilterDynamicFields.sort(function (a, b) {
            const captionA = a.title;
            const captionB = b.title;
            return captionA > captionB ? 1 : captionA < captionB ? -1 : 0;
          });
        }
      }
    },

    parseScreen() {
      this.screen.transaction = this.transactionEx.transaction;
      this.screen.formFieldsEx = this.transactionEx.formFieldsEx;
      this.screen.queryFieldsEx = this.transactionEx.queryFieldsEx;
      this.screen.actions = this.transactionEx.actions;
      this.screen.api = this.transactionEx.api;
      this.screen.catalogsEx = this.transactionEx.catalogsEx;
      this.screen.dictionariesEx = this.transactionEx.dictionariesEx;
      this.screen.errorMessages = this.transactionEx.errorMessages;
      this.screen.infoMessages = this.transactionEx.infoMessages;
      this.screen.isLogin = this.transactionEx.isLogin;
      this.screen.apiResponse = this.transactionEx.apiResponse;
      this.screen.bucket = this.transactionEx.bucket;
      this.screen.theme = this.transactionEx.theme;

      this.parseFilterDynamic();
      this.parseAllFormData();
      this.parseAllQueryData();
      this.parseAllQueryRichData();
      if (!this.formFirstFilterScreen(this.screen)) {
        this.parseQueryApi();
        this.parseCanvasApi();
        this.parseCalendarApi();
      }

      this.parseFormulas();
      //swap here (EYE ON IT)
      this.parseDynamicContent("form", null);

      //this.parseFormulas();
      this.parseMethod();
      if (!this.formFirstFilterScreen(this.screen)) {
        this.parseRefreshLapse();
      }
      this.parseBreadCrumbs();
    },

    parseBackTransaction() {
      if (this.backTransaction(this.screen)) {
        const error = !this.getTranApiSuccess(this.transactionEx);
        const context = this.translatedConfig(
          this.generalExApplicationEx,
          this.customLanguage,
          this.screen.transaction,
          "mainTitle"
        );
        const message = this.getTranApiMessagesEx(
          this.transactionEx,
          false,
          error
            ? context + ": " + this.errorMessage("processError")
            : context + ": " + this.translatedText("successText")
        );

        const okShow = this.sourceActionType == "foreign" ? error : true;

        if (okShow) {
          this.showDialog({
            custom: error ? "error" : "success",
            content: message,
          });
        }

        this.exitTransaction({
          data: this.transactionEx.apiResponse.data,
          result: this.transactionEx.apiResponse.success,
          actionType: this.actionType,
        });
      }
    },

    validateTransaction() {
      let result = true;

      if (!this.getTranApiSuccess(this.transactionEx)) {
        if (this.sourceAction?.type != "foreign") {
          this.showDialog({
            custom: "error",
            content: this.getTranApiMessages(this.transactionEx, true),
          });
        }
        result = false;
      }

      this.transactionEx.formFieldsEx.forEach((ffe) => {
        if (!this.findDictionary(this.screen, ffe.formField.dictionaryName)) {
          result = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage(
              "dictionaryError",
              "ff: " + ffe.formField.fieldName
            ),
          });
        }
      });
      this.transactionEx.queryFieldsEx.forEach((qfe) => {
        if (!this.findDictionary(this.screen, qfe.queryField.dictionaryName)) {
          result = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage(
              "dictionaryError",
              "qf: " + qfe.queryField.fieldName
            ),
          });
        }
      });
      return result;
    },

    launchConfirm(type) {
      this.submit.todo = true;

      this.showConfirm({
        content:
          this.translatedText("confirmText") +
          " " +
          this.translatedConfig(
            this.generalExApplicationEx,
            this.customLanguage,
            this.sourceAction,
            "caption"
          ).toLowerCase(),
        type,
      });
    },

    bringData(input) {
      if (input.transactionName != null) {
        this.cleanData();
        if (this.notBlank(input.transactionName)) {
          this.transactionName = input.transactionName;
          this.transactionLoaded = false;

          const body = this.inputData
            ? this.inputData
            : this.menu.inputFields
            ? this.basicBuildInputData(this.menu.inputFields, {})
            : {};

          const toConfirm = this.sourceActionConfirm() && !input.confirmed;

          if (!toConfirm) {
            this.loading = true;
            this.$emit("load-transaction", {
              transactionLoaded: this.transactionLoaded,
              transactionName: this.transactionName,
              loading: this.loading,
            });
            this.apiLoadProcess({
              headers: {
                method: this.transactionMethod,
                actionType: this.sourceActionType,
              },
              path: { transactionName: this.transactionName },
              body,
            })
              .then((transactionRes) => {
                this.transactionEx = transactionRes.data;

                if (this.validateTransaction()) {
                  this.transactionLoaded = true;
                  this.$emit("after-bring-data", {
                    transactionEx: this.transactionEx,
                    transactionLoaded: this.transactionLoaded,
                  });
                  this.parseScreen();
                  this.parseBackTransaction();
                  this.parseForeignKeys();
                } else {
                  this.exitTransaction({
                    data: this.transactionEx.apiResponse.data,
                    result: this.transactionEx.apiResponse.success,
                    actionType: this.actionType,
                    show: false,
                  });
                }

                this.loading = false;
                this.$emit("load-transaction", {
                  transactionLoaded: this.transactionLoaded,
                  transactionName: this.transactionName,
                  loading: this.loading,
                });
              })
              .catch((transactionErr) => {
                this.loading = false;
                this.showDialog({
                  custom: "error",
                  content: this.errorMessage("loadingError", transactionErr),
                });
              });
          } else {
            this.launchConfirm("action");
          }
        }
      }
    },

    // ------------------------------------------------------------------------
    // HANDLE INPUT CHANGES
    // ------------------------------------------------------------------------
    handleSingleFieldFormulas(
      field,
      fieldName,
      types,
      type,
      data,
      items,
      autoSource
    ) {
      let apply = false;
      let result = null;

      if (types.length == 0 || types.includes(type)) {
        const formulaFieldName = type + "Formula";

        if (this.notBlank(field[formulaFieldName])) {
          const okAllFields = !fieldName;

          let okInFormula = false;
          if (fieldName) {
            const words = field[formulaFieldName].split(" ");
            const filter = words.filter((word) => {
              return word
                .toLowerCase()
                .includes("data." + fieldName.toLowerCase());
            });
            okInFormula = filter.length > 0;
          }

          if (okAllFields || okInFormula) {
            const okAutoSource =
              !fieldName || !autoSource || fieldName != autoSource;
            if (okAutoSource) {
              try {
                const okFront = !field[formulaFieldName].includes("!front ");
                if (okFront) {
                  apply = true;
                  const front = true;
                  const global = {
                    now: moment().format("llll"),
                    nowFormatted: moment().format("YYYY-MM-DD"),
                    method: this.transactionMethod,
                    moment: moment,
                    applicationName: this.applicationName,
                    language: this.customLanguage,
                  };
                  const findItem = (
                    field,
                    itemId,
                    dictionaryName,
                    inputFields
                  ) => {
                    const items = this.findCatalogExList(
                      this.screen,
                      dictionaryName,
                      inputFields
                    );
                    const item = items
                      ? items.find((itemFind) => {
                          return itemFind.itemId == itemId;
                        })
                      : null;
                    return item ? item[field] : null;
                  };
                  result = eval(
                    field[formulaFieldName],
                    data,
                    items,
                    front,
                    global,
                    findItem
                  );
                }
              } catch (e) {
                apply = false;
                this.showDialog({
                  custom: "error",
                  content:  `Error in formula ${type} field ${fieldName} (${e})`
                });
              }
            }
          }
        }
      }

      return { apply, result };
    },

    handleDynamicFormulas(fieldName, types, start, autoSource) {
      const data = this.allFormData();

      Object.keys(this.formData).forEach((fieldId) => {
        const field = this.formData[fieldId];
        const index = this.formData[fieldId].index;
        const formField = this.screen.formFieldsEx[index].formField;
        const dictionaryName = formField.dictionaryName;

        const inputFields =
          this.screen.formFieldsEx[index].formField.inputFields;
        const items = this.findCatalogExList(
          this.screen,
          dictionaryName,
          inputFields
        );

        const access = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "access",
          data,
          items,
          autoSource
        );
        if (access.apply) {
          this.setFieldAccessExt(field.index, access.result);
        }

        const value = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "value",
          data,
          items,
          autoSource
        );
        if (value.apply) {
          const okNull = !start || !field.value;
          if (okNull) {
            this.setFieldValueExt(field.index, value.result, fieldName);
          }
        }

        const caption = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "caption",
          data,
          items,
          autoSource
        );
        if (caption.apply) {
          this.screen.formFieldsEx[field.index].formField.caption =
            caption.result;
        }

        const captionLan = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "captionLan",
          data,
          items,
          autoSource
        );
        if (captionLan.apply) {
          this.screen.formFieldsEx[field.index].formField.captionLan =
            captionLan.result;
        }

        const prefix = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "prefix",
          data,
          items,
          autoSource
        );
        if (prefix.apply) {
          this.screen.formFieldsEx[field.index].formField.prefix =
            prefix.result;
        }

        const suffix = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "suffix",
          data,
          items,
          autoSource
        );
        if (suffix.apply) {
          this.screen.formFieldsEx[field.index].formField.suffix =
            suffix.result;
        }

        const dynamicDictionary = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "dictionary",
          data,
          items,
          autoSource
        );
        if (dynamicDictionary.apply) {
          this.setFieldDictionaryExt(field.index, dynamicDictionary.result);
        }

        const customStyle = this.handleSingleFieldFormulas(
          field,
          fieldName,
          types,
          "customStyle",
          data,
          items,
          autoSource
        );
        if (customStyle.apply) {
          this.setFieldCustomStyleExt(field.index, customStyle.result);
        }
      });
    },

    handleDynamicCombos(indexSource) {
      const sourceFieldName =
        this.screen.formFieldsEx[indexSource].formField.fieldName;
      this.screen.formFieldsEx.forEach((formFieldEx) => {
        // Dinamically Loading
        const targetInputFields = formFieldEx.formField.inputFields;
        const targetInputFieldsArray = this.notBlank(targetInputFields)
          ? targetInputFields
              .split(",")
              .map((field) =>
                field.split(":").length > 1 ? field.split(":")[0] : field
              )
          : [];

        const targetLinkedSource =
          targetInputFieldsArray.includes(sourceFieldName);

        const dictionary = this.findDictionary(
          this.screen,
          formFieldEx.formField.dictionaryName
        );

        const isCatalog = this.isCatalog(dictionary);

        if (isCatalog && targetLinkedSource) {
          const isLast =
            targetInputFieldsArray == 1 ||
            targetInputFieldsArray[targetInputFieldsArray.length - 1] ==
              sourceFieldName;
          if (isLast) {
            this.parseDynamicContent("form", null, true);
          }
        }
      });
    },

    setFieldValueExt(index, value, autoSource) {
      this.screen.formFieldsEx[index].formField.defaultValue = value;
      this.setFormFieldAttrubute(index, "value", value, autoSource);
    },

    setFieldAccessExt(index, access) {
      const outputAccess = this.actualFieldAccess(access);

      this.screen.formFieldsEx[index].formField.access = outputAccess;
      const newAccess = outputAccess;
      const newRules = this.fieldRules(this.screen.formFieldsEx[index]);

      this.setFormFieldAttrubute(index, "access", newAccess);
      this.setFormFieldAttrubute(index, "rules", newRules);
    },

    setFieldCustomStyleExt(index, customStyle) {
      this.screen.formFieldsEx[index].formField.customStyle = customStyle;
      this.setFormFieldAttrubute(index, "customStyle", customStyle);
    },

    setFieldLoadingExt(index, query, value) {
      if (query) {
        this.setQueryRichFieldAttrubute(index, "loading", value);
      } else {
        this.setFormFieldAttrubute(index, "loading", value);
      }
    },

    setFieldDictionaryExt(index, value) {
      this.screen.formFieldsEx[index].formField.dictionaryName = value;
      this.parseDynamicContent("form", index);
    },

    setFieldUrlExt(index, value, autoSource) {
      this.setFormFieldAttrubute(index, "url", value, autoSource);
    },

    setFormFieldAttrubute(index, tag, value, autoSource) {
      if (index != null) {
        const fieldId = this.getFieldId(index);
        this.formData[fieldId][tag] = value;

        if (tag == "value") {
          if (this.$refs.transactionForm) {
            this.$refs.transactionForm.setFieldValue(
              fieldId,
              value,
              autoSource
            );
          }
        }
      }
    },

    setQueryRichFieldAttrubute(index, tag, value) {
      if (index) {
        const fieldId = this.getFieldId(index);
        this.queryRichData[fieldId][tag] = value;
      }
    },

    handleFirstElementCatalog(indexSource, items) {
      const formFieldEx = this.screen.formFieldsEx[indexSource];
      const dictionary = this.findDictionary(
        this.screen,
        formFieldEx.formField.dictionaryName
      );
      if (
        !this.queryConceptScreen(this.screen) &&
        formFieldEx &&
        this.apiCatalog(dictionary)
      ) {
        const emptyList = !items || !Array.isArray(items) || items.length == 0;
        const oneList = !emptyList && items.length == 1;
        const tags = this.comboTagField(dictionary);

        const fieldId = this.getFieldId(indexSource);
        const field = fieldId ? this.formData[fieldId] : null;
        const fieldName = field ? field.name : null;
        let fieldAccess = field ? field.access : null;

        if (!emptyList) {
          if (field) {
            fieldAccess = field.initialAccess;
            this.setFieldAccessExt(indexSource, fieldAccess);
            this.handleDynamicFormulas(null, ["access"], false, null);
          }
        }

        if (field && oneList && this.catalogFirst(dictionary)) {
          if (this.requiredField(fieldAccess)) {
            if (!field.value || field.value != items[0].itemId) {
              this.setFieldValueExt(indexSource, items[0].itemId, fieldName);
            }
          }
        }
        if (field) {
          let match = false;
          if (!emptyList) {
            items.forEach((item) => {
              if (item.itemId == formFieldEx.formField.defaultValue) {
                match = true;
              }
            });
          }

          if (!tags && (emptyList || !match)) {
            let fId = this.getFieldId(indexSource);
            let f = this.formData[fId];
            let fName = f.name;
            if (this.notBlank(f.value)) {
              this.setFieldValueExt(indexSource, "", fName);
            }
          }
        }
      }
    },

    handleOtherExtendedCatalog(indexSource, items) {
      const ffe = this.screen.formFieldsEx[indexSource];
      this.screen.formFieldsEx.forEach((evfe, evalIndex) => {
        if (this.notBlank(evfe.formField.otherCatalog)) {
          const fieldId = this.getFieldId(indexSource);
          const fieldName = ffe.formField.fieldName;
          const value = this.formData[fieldId].value;
          const arrayFields = evfe.formField.otherCatalog.split(",");
          const arrayFieldObjects = arrayFields.map((field) => {
            let fieldObject = field.includes(":")
              ? {
                  source: field.split(":")[0],
                  extended: field.split(":")[1],
                }
              : { source: field, extended: field };
            return fieldObject;
          });

          arrayFieldObjects.forEach((fo, fi) => {
            if (fo.source == ffe.formField.fieldName) {
              this.parseDynamicContent("form", fi);
              const localItems = items
                ? items
                : this.findCatalogExList(
                    this.screen,
                    ffe.formField.dictionaryName,
                    this.buildInputData(ffe.formField.inputFields)
                  );

              localItems.forEach((item) => {
                if (value == item.itemId) {
                  const extendedValue =
                    typeof item[fo.extended] == "number"
                      ? item[fo.extended].toString()
                      : item[fo.extended];
                  const currentChanges = this.changeHappened;

                  this.setFieldValueExt(evalIndex, extendedValue, fieldName);
                  this.changeHappened = currentChanges
                    ? this.changeHappened
                    : false;
                }
              });
            }
          });
        }
      });
    },

    handleChangeFilterQuery(data) {
      if (this.queryScreen(this.screen)) {
        const filterChange = this.formData[data.id].filterChange;
        const field = this.formData[data.id];
        if (
          filterChange &&
          (!data.autoSource || data.autoSource != field.name)
        ) {
          if (this.$refs.transactionForm.setFormValidation())
            this.reloadQuery();
        }
      } else if (this.calendarScreen(this.screen)) {
        const filterChange = this.formData[data.id].filterChange;
        const field = this.formData[data.id];
        if (
          filterChange &&
          (!data.autoSource || data.autoSource != field.name)
        ) {
          this.reloadCalendar();
        }
      }
    },

    handleChangeForeignKey(data) {
      const field = this.formData[data.id];
      const ffe = field ? this.screen.formFieldsEx[field.index] : null;
      if (
        field &&
        ffe &&
        data.autoSource &&
        this.notBlank(ffe.formField.foreignKey) &&
        ffe.formField.fieldName != data.autoSource
      ) {
        this.handleForeignKey({
          id: this.getFieldId(field.index),
          value: field.value,
          transactionName: ffe.formField.foreignKey,
          index: field.index,
        });
      }
    },

    handleChange(data) {
      this.userInteraction({
        type: "transaction-change",
        data: { transaction: this.transactionName },
      });

      this.changesLog.push();

      const fields = Object.keys(data);

      fields.forEach((field) => {
        this.formData[data.id][field] = data[field];
      });

      this.handleDynamicFormulas(
        this.formData[data.id].name,
        [],
        false,
        data.autoSource
      );

      this.handleDynamicCombos(this.formData[data.id].index, []);

      this.handleOtherExtendedCatalog(this.formData[data.id].index);

      this.handleChangeFilterQuery(data);

      this.handleChangeForeignKey(data);

      this.changeHappened = true;
    },

    handleQueryDynamicFormulas(args) {
      // Evaluate Value
      const { coordinates, autoSource } = args;
      const { recordId, fieldId } = coordinates;
      const fieldNameSource = coordinates.fieldName;

      this.screen.queryFieldsEx.forEach((qfe, qfeIndex) => {
        const queryField = qfe.queryField;
        const fieldName = queryField.fieldName;
        const valueFormula = queryField.valueFormula;

        if (
          fieldId != qfeIndex &&
          valueFormula &&
          valueFormula.includes("data." + fieldNameSource) &&
          (!autoSource || autoSource != fieldName)
        ) {
          const data = this.queryData[recordId];
          const result = eval(valueFormula, data);

          if (this.$refs.transactionQuery) {
            this.$refs.transactionQuery.setFieldValue({
              id: this.cellId(fieldName, recordId),
              coordinates: {
                recordId,
                fieldId: qfeIndex,
                fieldName,
              },
              value: result,
              autoSource: fieldNameSource,
            });
          }
        }
      });
    },

    handleChangeQuery(data) {
      this.changesLog.push(data);

      if (data.coordinates) {
        const coordinates = data.coordinates;
        this.smartSetValue(
          this.queryData[coordinates.recordId],
          coordinates.fieldName,
          data.value
        );
        //this.queryData[coordinates.recordId][coordinates.fieldName] =
        //  data.value;
        this.changeQueryHappened = true;
        this.handleQueryDynamicFormulas(data);
      }
    },

    updateAndRender() {
      this.renderKey++;
    },

    handleBrowseHelp(data) {
      const inputFieldsArray = this.combineInputStructures([
        this.formData[data.id].name,
        this.screen.formFieldsEx[data.index].formField.inputFields,
      ]);
      this.callAction({
        action: {
          type: "browse",
          destTranName: data.transactionName,
          inputFields: this.unParseInputStructure(inputFieldsArray),
          outputFields:
            this.screen.formFieldsEx[data.index].formField.outputFields,
          method: "get",
          outputAction: "selection",
        },
        coordinates: {
          index: data.index,
          fieldId: data.id,
        },
      });
    },

    handleForeignKey(args) {
      const data = args ? args : this.foreignKeyArray[this.foreignKeyIndex];

      const inputFields =
        this.screen.formFieldsEx[data.index].formField.inputFields;
      const outputFields =
        this.screen.formFieldsEx[data.index].formField.outputFields;
      const inputFieldsArray = this.combineInputStructures([
        this.formData[data.id].name,
        inputFields,
      ]);

      this.callAction({
        action: {
          type: "foreign",
          destTranName: data.transactionName,
          inputFields: this.unParseInputStructure(inputFieldsArray),
          outputFields: outputFields,
          method: "get",
        },
        coordinates: {
          index: data.index,
          fieldId: data.id,
        },
      });
    },

    // ---------------------------------------------------------------------
    // SPECIAL FUNCTIONS
    // ---------------------------------------------------------------------

    loadedTransaction() {
      return this.menu.selected && this.transactionLoaded;
    },

    formApiScreen() {
      return this.notBlank(this.screen.transaction.apiName);
    },

    formLogin() {
      return this.screen.isLogin === true;
    },

    queryApiScreen() {
      return this.queryScreen(this.screen) /*&&
        this.screen.transaction.sourceType === "api"*/;
    },

    canvasApiScreen() {
      return this.canvasScreen(this.screen) /*&&
        this.screen.transaction.sourceType === "api"*/;
    },

    calendarApiScreen() {
      return this.calendarScreen(this.screen) /*&&
        this.screen.transaction.sourceType === "api"*/;
    },

    cleanData() {
      this.transactionEx = {};
      this.screen = {
        transaction: {},
        formFieldsEx: [],
        queryFieldsEx: [],
        actions: [],
        api: {},
        errorMessages: [],
        infoMessages: [],
        apiResponse: {},
        bucket: {},
        theme: {},
      };
      this.queryData = [];
      this.queryExtendedData = [];
      this.queryHeader = null;
      this.queryActions = [];
      this.queryLoaded = false;
      this.queryFirstLoaded = false;
      this.queryTimeout = null;
      this.querySort = [];
      this.queryChecks = [];
      this.queryUploadLog = [];
      this.queryRichData = {};

      this.queryPage = 0;
      this.queryLimit = 10;
      this.querySortField = null;
      this.querySortType = null;

      this.queryError = false;

      this.dialog = {};
      this.confirm = {};
      this.messages = [];
      this.embed = {};
      (this.transactionName = ""), (this.transactionLoaded = false);
      this.formData = {};

      this.formFilterDynamic = false;
      this.formFilterDynamicFields = [];
      this.fieldFilter = null;
      this.showFieldFilter = false;
      this.oneFieldFilter = false;

      this.changeHappened = false;
      this.changesLog = [];

      this.canvasData = {};
      this.canvasActions = {};

      this.search = null;

      this.foreignKeyArray = [];
      this.foreignKeyIndex = -1;

      this.submit = {
        todo: false,
        done: false,
        close: this.closeSubmit,
      };

      (this.calendarData = []),
        (this.calendarEvents = []),
        (this.calendarLoaded = false),
        (this.renderKey = 0);
    },

    // ---------------------------------------------------------------------
    //      SUBMIT
    // ---------------------------------------------------------------------
    filesData() {
      let filesArray = [];
      this.screen.formFieldsEx.forEach((formFieldEx, index) => {
        const dictionary = this.findDictionary(
          this.screen,
          formFieldEx.formField.dictionaryName
        );
        if (this.fileInputField(dictionary)) {
          const data = this.formData[this.getFieldId(index)];
          if (data.selected) {
            data.file.index = index;
            filesArray.push({
              file: data.file,
              buffer: data.buffer,
              inputFields: formFieldEx.formField.inputFields,
              fieldName: formFieldEx.formField.fieldName,
              temporal: dictionary.temporalFile,
            });
          }
        }
      });
      return filesArray;
    },

    promiseSubmitUploads() {
      const filesArray = this.filesData();
      const fetchFile = (fileData) =>
        this.promiseUploadFile({
          file: fileData.file,
          buffer: fileData.buffer,
          envData: {
            generalEx: this.generalExApplicationEx.generalEx,
            applicationEx: this.generalExApplicationEx.applicationEx,
            transactionEx: this.transactionEx,
          },
          tranData: this.buildInputData(fileData.inputFields),
          fieldName: fileData.fieldName,
        });
      const promisesArray = filesArray.map(fetchFile);
      return Promise.all(promisesArray);
    },

    updateUploads(response) {
      const filesArray = this.filesData();
      filesArray.forEach((fileData, i) => {
        const index = this.getFieldId(fileData.file.index);
        const value =
          response[i].data.data.access == "PUBLIC" || fileData.temporal
            ? response[i].data.data.url
            : response[i].data.data.key;
        const url = response[i].data.data.url;
        this.formData[index].value = value;
        this.formData[index].url = url;
        this.formData[index].selected = false;
        this.formData[index].progress = 100;
        this.formData[index].uploaded = true;
      });
      this.$forceUpdate();
    },

    submitTransaction() {
      this.userInteraction({
        type: "transaction-submit",
        data: { transaction: this.transactionName },
      });
      let body = this.allFormData();
      let method = this.transactionMethod;
      const originalTransactionName = this.transactionName;

      // Form
      if (this.isSubmitToDoProcess()) {
        this.submitting = true;

        this.apiDoProcess({
          path: { transactionName: this.transactionName },
          headers: { method },
          body,
        })
          .then((updateRes) => {
            this.tranApiExceptions(updateRes.data, this.generalExApplicationEx);

            this.submitting = false;
            this.changeHappened = false;
            this.transactionEx = updateRes.data;
            this.transactionName = this.transactionEx.transaction.name;
            this.parseScreen();
            this.parseForeignKeys();

            const jumpScreen = originalTransactionName != this.transactionName;

            this.$emit(
              "transaction-process",
              this.getTranApiSuccess(updateRes.data),
              body,
              updateRes.data
            );

            if (!this.showSuccess) {
              if (this.getTranApiSuccess(updateRes.data)) {
                if (!jumpScreen) {
                  const message = this.getTranApiMessages(
                    updateRes.data,
                    false
                  );
                  const customMessage =
                    message &&
                    ((Array.isArray(message) && message.length > 0) ||
                      typeof message == "string");
                  this.showDialog({
                    custom: "success",
                    content: customMessage
                      ? message
                      : this.translatedText("successText"),
                  });
                }
              } else {
                this.showDialog({
                  custom: "error",
                  content: this.getTranApiMessages(updateRes.data, true),
                });
                this.changeHappened = true;
              }
            }
            if (this.autoCloseEmbedTransactionOnSubmit(jumpScreen)) {
              this.exitTransaction({ show: false });
            }
            if (jumpScreen) {
              this.formScreen(this.screen)
                ? (this.transactionMethod = "post")
                : (this.transactionMethod = "get");
              this.updateAndRender();
            }
          })
          .catch((updateError) => {
            this.submitting = false;
            this.$emit("transaction-process", false, body, updateError);
            if (!this.showError || this.showError === true) {
              this.showDialog({
                custom: "error",
                content: this.errorMessage(
                  "processError",
                  this.screen.transaction.mainTitle
                ),
              });
            }
            if (this.submit.todo == true) {
              this.exitTransaction({ show: false });
            }
          });
      } else if (this.isSubmitQueryFilter()) {
        this.parseQueryApi();
        this.parseRefreshLapse();
      } else if (this.isSubmitCalendarFilter()) {
        this.parseCalendarApi();
      }
    },

    submitForm() {
      this.submitting = true;
      this.promiseSubmitUploads()
        .then((uploadsRes) => {
          this.submitting = false;
          if (this.getArrayTranApiSuccess(uploadsRes)) {
            this.updateUploads(uploadsRes);
            this.submitTransaction();
          } else {
            this.showDialog({
              custom: "error",
              content: this.errorMessage(
                "uploadingError",
                this.getArrayTranApiMessages(uploadsRes, true)
              ),
            });
          }
        })
        .catch((uploadsErr) => {
          this.submitting = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage("uploadingError", uploadsErr),
          });
        });
    },

    submitCanvas() {
      this.submitTransaction();
    },

    // ---------------------------------------------------------------------
    //      ACTIONS
    // ---------------------------------------------------------------------

    allInputDataForm(inputFieldsArray) {
      let data = {};
      inputFieldsArray.forEach((inputField) => {
        const { sourceName, destName } = this.formatInputField(inputField);
        if (!inputField.includes("=")) {
          data[destName] = this.getFieldValueByName(
            sourceName,
            this.screen.formFieldsEx,
            this.formData
          );
        } else {
          const list = inputField.split("=");
          data[list[0]] = list[1];
        }
      });
      return data;
    },

    allInputDataQuery(inputFieldsArray, coordinates) {
      let data = {};
      const { recordId } = coordinates;
      if (recordId != null && recordId < this.allQueryData().length) {
        const record = this.allQueryData()[recordId];
        inputFieldsArray.forEach((inputField) => {
          let { sourceName, destName } = this.formatInputField(inputField);
          if (sourceName.includes("=")) {
            const list = sourceName.split("=");
            sourceName = list[0];
            destName = list[0];
            data[destName] = list[1];
          } else {
            data[destName] = this.smartFieldValue(record, sourceName); // record[sourceName];
          }
        });
      }
      inputFieldsArray.forEach((inputField) => {
        let { sourceName, destName } = this.formatInputField(inputField);

        if (!sourceName.includes("=") && data[destName] == null) {
          data[destName] = this.getFieldValueByName(
            sourceName,
            this.screen.formFieldsEx,
            this.formData
          );
        }
      });
      return data;
    },

    allInputDataCalendar(inputFieldsArray, coordinates) {
      let data = {};
      const record = coordinates.event.data;
      inputFieldsArray.forEach((inputField) => {
        const { sourceName, destName } = this.formatInputField(inputField);
        data[destName] = record[sourceName];
      });
      return data;
    },

    allBulkDataQuery(inputFieldsArray) {
      let data = this.allInputDataForm(inputFieldsArray);
      let list = [];
      this.allQueryData().forEach((record, recordId) => {
        let outputRecord =
          inputFieldsArray.length == 0
            ? record
            : this.allInputDataQuery(inputFieldsArray, {
                recordId,
              });
        outputRecord.check = this.queryChecks[recordId];
        list.push(outputRecord);
      });
      return { data, list };
    },

    allInputDataCanvas(inputFieldsArray, coordinates) {
      let data = {};
      const { page, line, column } = coordinates;
      data[this.singular(this.pagesName())] = page;
      data[this.singular(this.linesName())] = line;
      data[this.singular(this.columnsName())] = column;
      inputFieldsArray.forEach((inputField) => {
        const { sourceName, destName } = this.formatInputField(inputField);
        const _page = this.canvasData[this.pagesName()][page];
        const _line = _page[this.linesName()][line];
        const _column = _line[this.columnsName()];
        const _itemData = _column[column]
          ? _column[column][this.itemsName()][0][sourceName]
          : null;
        const _inputData = this.inputData[sourceName];
        if (_itemData != null) {
          data[destName] = _itemData;
        } else if (_inputData != null) {
          data[destName] = _inputData;
        }
      });
      return data;
    },

    callAction(params) {
      this.userInteraction({
        type: "transaction-action",
        data: { transaction: this.transactionName },
      });
      const okTranName = this.notBlank(params.action.destTranName);
      const okScript = this.notBlank(params.action.executeScript);
      const okSelection = params.action.outputAction == "selection";
      if (okTranName || okScript || okSelection) {
        let data = {};

        if (params.inputData) {
          data = params.inputData;
        } else {
          const inputFieldsArray = params.action.inputFields
            ? params.action.inputFields.split(",")
            : [];
          switch (params.action.type) {
            default: {
              data = this.allInputDataForm(inputFieldsArray);
              break;
            }
            case "bulkCheck":
            case "bulkContent":
            case "bulkDynamic": {
              data = this.allBulkDataQuery(inputFieldsArray);
              break;
            }
            case "dynamic":
            case "floating": {
              if (this.queryScreen(this.screen)) {
                data = this.allInputDataQuery(
                  inputFieldsArray,
                  params.coordinates
                );
              } else if (this.canvasScreen(this.screen)) {
                data = this.allInputDataCanvas(
                  inputFieldsArray,
                  params.coordinates
                );
              } else if (this.calendarScreen(this.screen)) {
                data = this.allInputDataCalendar(
                  inputFieldsArray,
                  params.coordinates
                );
              }
              break;
            }
          }
        }
        //}
        if (okTranName) {
          this.showEmbed({
            custom: params.action.type,
            transactionName: params.action.destTranName,
            inputData: data,
            method: params.action.method,
            coordinates: params.coordinates,
            sourceActionType: params.action.type,
            sourceAction: params.action,
            outputFields: params.action.outputFields,
          });
        } else if (okScript) {
          const addQueryRecord = (addRecord) => {
            this.queryData.push(addRecord ?? {});
            this.queryCount++;
          };
          const deleteQueryRecord = (index) => {
            this.queryData.splice(index, 1);
            this.queryCount--;
            this.changeQueryHappened = true;
          };
          const coordinates = params.coordinates;
          const global = {
            now: moment().format("llll"),
            nowFormatted: moment().format("YYYY-MM-DD"),
            method: this.transactionMethod,
            moment: moment,
            applicationName: this.applicationName,
            language: this.customLanguage,
            addQueryRecord,
            deleteQueryRecord,
            coordinates,
          };
          eval(params.action.executeScript, data, global, params.coordinates);
        } else if (okSelection) {
          this.exitTransaction({
            data,
            result: true,
            actionType: params.action.type,
            show: false,
          });
        }
      } else {
        this.showDialog({
          custom: "info",
          content: "No transaction defined for action",
        });
      }
    },

    callTransaction(getMenu, getActionType) {
      this.transactionName = getMenu.transactionName;
      this.actionType = getActionType;
      this.transactionMethod = getMenu.method ? getMenu.method : this.method;
      this.bringData({ transactionName: getMenu.transactionName });
    },

    // ---------------------------------------------------------------------
    //      QUERY
    // ---------------------------------------------------------------------

    allQueryData() {
      let result =
        this.queryData && Array.isArray(this.queryData)
          ? this.queryData.map((record, index) => {
              let target = record;
              target.__oriIndex = index;
              return target;
            })
          : [];
      if (this.notBlank(this.search)) {
        const search = this.search ? this.search.toLowerCase() : "";
        result = result.filter(function (record) {
          const fields = Object.keys(record);
          let okFilter = false;
          fields.forEach((field) => {
            if (record[field] != null) {
              const fieldText = record[field].toString().toLowerCase();
              if (fieldText.includes(search)) {
                okFilter = true;
              }
            }
          });
          return okFilter;
        });
      }
      return result;
    },

    setPageQueryData() {
      this.queryPages = Math.ceil(this.queryCount / this.queryLimit);
    },

    setQueryData() {
      if (this.queryData != null && this.queryData != []) {
        // Actions
        this.queryActions.length = this.queryCount;
        // Sort
        if (this.querySort.length == 0) {
          this.screen.queryFieldsEx.forEach((queryFieldEx, index) => {
            const name = queryFieldEx.queryField.fieldName;
            this.querySort.push({ name, index, sort: null });
          });
        } else {
          if (!this.pageableQuery(this.screen)) {
            this.querySort.forEach((field, index) => {
              if (field.sort) {
                this.sortColumn(index, field.sort);
              }
            });
          }
        }
        // Bulk
        this.queryChecks = [];
        this.queryChecks.length = 0;
        for (let i = 0; i < this.queryCount; i++) {
          this.queryChecks[i] = false;
        }
        if (this.$refs.transactionQuery) {
          this.$refs.transactionQuery.initChecks(this.queryChecks);
        }
        this.updateAndRender();
      }
    },

    setQueryExtendedData() {
      try {
        this.queryExtendedData = this.queryData.map((record, index) => {
          let output = {};
          this.screen.queryFieldsEx.forEach((qfe) => {
            output[qfe.queryField.fieldName] = {};
          });
          return {
            index,
            data: output,
          };
        });
      } catch (e) {
        this.showDialog({
          custom: "error",
          content: this.errorMessage("queryExtendedDataError", e),
        });
      }
    },

    setQueryHeader() {
      if (
        this.queryScreen(this.screen) &&
        this.queryHeader &&
        !Array.isArray(this.queryHeader) &&
        Object.keys(this.queryHeader).length > 0
      ) {
        Object.keys(this.queryHeader).forEach((headerKey) => {
          Object.keys(this.formData).forEach((formKey) => {
            const formItem = this.formData[formKey];
            if (formItem.name == headerKey) {
              const headerValue =
                typeof this.queryHeader[headerKey] == "number"
                  ? this.queryHeader[headerKey].toString()
                  : this.queryHeader[headerKey];
              this.setFieldValueExt(formItem.index, headerValue, formItem.name);
            }
          });
        });
      }
    },

    setQueryFormulas() {
      if (this.queryScreen(this.screen)) {
        const data = this.allFormData();
        this.screen.queryFieldsEx.forEach((qfe, index) => {
          if (qfe.queryField.captionFormula) {
            const caption = eval(qfe.queryField.captionFormula, data);
            this.screen.queryFieldsEx[index].queryField.caption = caption;
          }
          if (qfe.queryField.captionLanFormula) {
            const captionLan = eval(qfe.queryField.captionLanFormula, data);
            this.screen.queryFieldsEx[index].queryField.captionLan = captionLan;
          }
        });
      }
    },

    sortColumn(column, forced) {
      const currentStatus = this.querySort[column].sort;
      this.querySort.forEach((field, index) => {
        this.querySort[index].sort = null;
      });
      if (forced) {
        this.querySort[column].sort = forced;
      } else {
        this.querySort[column].sort = !currentStatus
          ? "asc"
          : currentStatus == "asc"
          ? "desc"
          : "asc";
      }
      const fieldName = this.querySort[column].name;
      const sort = this.querySort[column].sort;

      this.querySortField = fieldName;
      this.querySortType = sort;

      if (this.pageableQuery(this.screen)) {
        this.reloadQuery();
      } else {
        this.queryData.sort(function (a, b) {
          const formatA = a[fieldName] ? a[fieldName] : "";
          const formatB = b[fieldName] ? b[fieldName] : "";
          if (sort == "asc") {
            return formatA > formatB ? 1 : formatA < formatB ? -1 : 0;
          } else if (sort == "desc") {
            return formatB > formatA ? 1 : formatB < formatA ? -1 : 0;
          }
        });
      }
    },

    reloadQuery() {
      this.messages = [];
      if (this.queryScreen(this.screen)) {
        this.parseQueryApi();
        this.parseRefreshLapse();
      } else if (this.calendarScreen(this.screen)) {
        this.parseCalendarApi();
      }
    },

    updatePageQuery(page) {
      this.queryPage = page;
      this.reloadQuery();
    },

    updatePageLimit(limit) {
      this.queryLimit = limit;
      this.reloadQuery();
    },

    reloadCalendar() {
      this.messages = [];
      this.parseCalendarApi();
    },

    // ---------------------------------------------------------------------
    //      FLAPS
    // ---------------------------------------------------------------------

    selectFlap(getSelected) {
      this.$emit("select-flap", getSelected);
    },

    // ---------------------------------------------------------------------
    //      CANVAS
    // ---------------------------------------------------------------------

    getAddIndex(getIndex, getMode) {
      let index = getIndex;
      switch (getMode) {
        case "above": {
          index--;
          break;
        }
        case "bellow": {
          index++;
          break;
        }
      }
      return index;
    },

    canvasTags() {
      const tags = this.screen.transaction.canvasTags
        ? this.screen.transaction.canvasTags.split(",")
        : [];
      return tags;
    },

    pagesName() {
      const tags = this.canvasTags();
      return tags.length >= 1 ? tags[0] : "pages";
    },

    linesName() {
      const tags = this.canvasTags();
      return tags.length >= 2 ? tags[1] : "lines";
    },

    columnsName() {
      const tags = this.canvasTags();
      return tags.length >= 3 ? tags[2] : "columns";
    },

    itemsName() {
      const tags = this.canvasTags();
      return tags.length >= 4 ? tags[3] : "items";
    },

    canvasAddPage(getPage, getMode) {
      let index = this.getAddIndex(getPage, getMode);
      let zeroPage = {};
      zeroPage[this.linesName()] = [];
      this.canvasData[this.pagesName()].splice(index, 0, zeroPage);
    },

    canvasAddLine(getPage, getLine, getMode) {
      let index = this.getAddIndex(getLine, getMode);
      let zeroLine = {};
      zeroLine[this.columnsName()] = [];
      this.canvasData[this.pagesName()][getPage][this.linesName()].splice(
        index,
        0,
        zeroLine
      );
    },

    canvasAddColumn(getPage, getLine, getColumn, getMode) {
      let index = this.getAddIndex(getColumn, getMode);
      let zeroColumn = {};
      zeroColumn[this.itemsName()] = [];
      this.canvasData[this.pagesName()][getPage][this.linesName()][getLine][
        this.columnsName()
      ].splice(index, 0, zeroColumn);
    },

    canvasDeletePage(getPage) {
      this.canvasData[this.pagesName()].splice(getPage, 1);
    },

    canvasDeleteLine(getPage, getLine) {
      this.canvasData[this.pagesName()][getPage][this.linesName()].splice(
        getLine,
        1
      );
    },

    canvasDeleteColumn(getPage, getLine, getColumn) {
      this.canvasData[this.pagesName()][getPage][this.linesName()][getLine][
        this.columnsName()
      ].splice(getColumn, 1);
    },

    // --------------------------------------------------------------------
    //      ALERTS
    // --------------------------------------------------------------------

    alert() {
      let result = null;
      if (this.queryError) {
        result = {
          content: this.errorMessage("queryError"),
          custom: "error",
        };
      }
      if (this.messages.length > 0) {
        result = this.messages[this.messages.length - 1];
      }
      return result;
    },

    // --------------------------------------------------------------------
    //      SEARCH
    // --------------------------------------------------------------------

    visibleSearch() {
      const search = this.queryScreen(this.screen) && this.queryLoaded;
      const filter = this.formFilterScreen({
        screen: this.screen,
        interactive: true,
        dynamic: this.formFilterDynamic,
      });
      return search && !filter;
    },

    showSearch() {
      this.search = this.search == null ? "" : null;
    },

    showNavBar() {
      return (
        this.loadedTransaction() &&
        !this.backTransaction(this.screen) &&
        (!this.custom || !this.custom.hideHeader)
      );
    },

    showLoadingSkeleton() {
      return (
        !this.transactionLoaded &&
        this.notBlank(this.transactionName) &&
        !this.backTransaction(this.screen) &&
        !this.foreignKeyAction(this.actionType)
      );
    },

    showFlap(index) {
      let result = false;
      if (
        this.transactionMethod == "post" ||
        this.transactionMethod == "delete"
      ) {
        result = index == 0;
      } else {
        result =
          this.flaps.items[index].access != null
            ? this.flaps.items[index].access
            : true;
      }
      return result;
    },

    finishTransaction(data) {
      if (this.queryScreen(this.screen)) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
      }
      //this.transactionLoaded = false;
      //this.transactionName = "";
      this.$emit("exit-transaction", data);
    },

    exitTransaction(data) {
      this.finishTransaction(data);
    },

    onResize() {
      const doMount = this.transactionSize != this.screenSize();
      this.transactionSize = this.screenSize();
      if (doMount) {
        this.updateAndRender();
      }
    },

    queryCheckChange(checks) {
      this.queryChecks = checks;
    },

    isSubmitToDoProcess() {
      const regularSubmit = this.formScreen(this.screen);
      return regularSubmit;
    },

    isSubmitQueryFilter() {
      return (
        this.formFilterScreen({
          screen: this.screen,
          interactive: false,
          dynamic: this.formFilterDynamic,
        }) && this.queryApiScreen()
      );
    },

    isSubmitCalendarFilter() {
      return (
        this.formFilterScreen({
          screen: this.screen,
          interactive: false,
          dynamic: this.formFilterDynamic,
        }) && this.calendarApiScreen()
      );
    },

    switchLanguage() {
      this.parseBreadCrumbs();
      this.parseDynamicContent("both");
      this.$emit("switch-language");
    },

    setLoading(status) {
      this.loading = status;
    },

    queryFileUpload(data) {
      const body = {
        fieldName: null,
        inputData: null,
        type: "xlsx",
        file: data.binary,
      };
      //const body = {
      //          fieldName: data.fieldName,
      //          inputData: data.inputData,
      //          type: data.type,
      //          file: data.file,
      //      };
      this.querying = true;
      this.apiUploadQuery({
        path: { transactionName: this.transactionName },
        body,
      })
        .then((queryUploadRes) => {
          this.querying = false;
          const apiResponse = queryUploadRes.data;
          if (this.getApiSuccess(apiResponse)) {
            this.showDialog({
              custom: "success",
              content: this.getApiMessages(apiResponse, false),
            });
          } else {
            this.queryUploadLog = this.getApiMessages(apiResponse, true);
            this.showDialog({
              custom: "error",
              content: this.errorMessage("uploadFileError"),
            });
            setTimeout(() => {
              this.showQueryUploadLog();
            }, this.messagesTime);
          }
          this.reloadQuery();
        })
        .catch((queryDownloadError) => {
          this.querying = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage("downloadFileError", queryDownloadError),
          });
        });
    },

    queryFileDownload(fileType) {
      const body = this.parseDataForQuery();
      this.querying = true;
      this.apiDownloadQuery({
        path: { transactionName: this.transactionName },
        params: this.getQueryParams(fileType),
        body,
      })
        .then((queryDownloadRes) => {
          this.querying = false;
          const apiResponse = queryDownloadRes.data;
          if (this.getApiSuccess(apiResponse)) {
            this.downloadFileFromUrl(apiResponse.data.url, [
              this.translatedConfig(
                this.generalExApplicationEx,
                this.customLanguage,
                this.screen.transaction,
                "mainTitle"
              ),
              this.screen.formFieldsEx
                .map((ffe, ffeIndex) => {
                  return {
                    index: ffeIndex,
                    caption: this.translatedConfig(
                      this.generalExApplicationEx,
                      this.customLanguage,
                      ffe.formField,
                      "caption"
                    ),
                    value: this.getField(ffeIndex).value,
                  };
                })
                .filter((map) => {
                  return map.value;
                })
                .map((map) => map.caption + ":" + map.value)
                .join(","),
              this.session.details.userName,
              moment().format("yyyy-MM-DD"),
              moment().format("HHmm"),
            ]);
          } else {
            this.showDialog({
              custom: "error",
              content: this.getApiMessages(apiResponse, true),
            });
          }
        })
        .catch((queryDownloadError) => {
          this.querying = false;
          this.showDialog({
            custom: "error",
            content: this.errorMessage("downloadFileError", queryDownloadError),
          });
        });
    },

    showStaticDialog(data) {
      this.staticDialog = data;
      this.staticDialog.show = true;
    },

    closeStaticDialog(data) {
      this.staticDialog = data;
      this.staticDialog.show = false;
    },

    showQueryUploadLog() {
      this.showStaticDialog({
        custom: "error",
        content: this.queryUploadLog.map((item) => {
          return {
            custom: "error",
            content: "(" + moment().format("LTS") + ") " + item,
          };
        }),
      });
    },

    changeQueryFileInputUpload() {
      this.getBase64(this.fileUpload).then((binary) => {
        const data = {
          binary,
          name: this.fileUpload.name,
        };
        this.queryFileUpload(data);
        this.fileUpload = null;
      });
    },

    activateQueryFileInputUpload() {
      this.$refs.queryFileUploadRef.$refs.input.click();
    },

    queryFileActions() {
      let arrayUpload = [];
      let arrayDownload = [];
      if (this.queryFileDownloadScreen(this.screen)) {
        arrayDownload.push({
          caption: this.translatedText("exportText") + " Excel",
          icon1: "mdi-download",
          icon2: "mdi-microsoft-excel",
          action: () => {
            this.queryFileDownload("EXCEL");
          },
        });
        /*
        arrayDownload.push({
          caption: this.translatedText("downloadText") + ' PDF',
          icon1: "mdi-file-pdf-box",
          icon2: "mdi-download",
          action: () => {
            this.queryFileDownload("pdf");
          },
        });
        */
      }
      if (this.queryFileUploadScreen(this.screen)) {
        arrayDownload.push({
          caption: this.translatedText("importText") + " Excel",
          icon1: "mdi-cloud-upload",
          icon2: "mdi-microsoft-excel",
          action: () => {
            this.activateQueryFileInputUpload();
          },
          input: true,
        });
      }
      return arrayUpload.concat(arrayDownload);
    },

    underProcessing() {
      return (
        (!this.custom || !this.custom.hideWait) &&
        (this.loading ||
          //this.cataloging ||
          //this.dictionarying ||
          this.submitting ||
          (this.querying && !this.secondaryUnderProcessing()))
      );
    },

    secondaryUnderProcessing() {
      return (
        ((!this.custom || !this.custom.hideWait) &&
          this.querying &&
          this.queryFirstLoaded) ||
        this.cataloging ||
        this.dictionarying
      );
    },

    addFormFieldEx(params) {
      const formField = params;
      const formFieldEx = { formField };
      const i = this.screen.formFieldsEx.push(formFieldEx) - 1;

      let dictionary = this.findDictionary(
        this.screen,
        formFieldEx.formField.dictionaryName
      );
      let access = this.getFieldAccess(
        formField.access,
        this.menu.permission,
        this.transactionMethod
      );
      let rules = [];

      this.parseFormData({
        id: i,
        name: formField.fieldName,
        type: this.getValueType(dictionary),
        value: formField.defaultValue,
        access,
        rules,
        customStyle: formField.customStyle,
        accessFormula: formField.accessFormula,
        valueFormula: formField.valueFormula,
        captionFormula: formField.captionFormula,
        captionLanFormula: formField.captionLanFormula,
        prefixFormula: formField.prefixFormula,
        suffixFormula: formField.suffixFormula,
        dictionaryFormula: formField.dictionaryFormula,
        customStyleFormula: formField.customStyleFormula,
        loading: false,
      });

      this.parseDynamicContent("form");
    },

    changeFieldFilter() {
      if (this.fieldFilter) {
        this.oneFieldFilter = true;
      }

      this.formFilterDynamicFields.forEach((ffdf) => {
        let find = null;

        this.fieldFilter &&
          this.fieldFilter.forEach((filter) => {
            if (filter.oriIndex == ffdf.oriIndex) {
              find = filter;
            }
          });

        const currentAccess =
          this.screen.formFieldsEx[ffdf.oriIndex].formField.access;

        if (find && currentAccess != "optional") {
          this.setFieldAccessExt(ffdf.oriIndex, "optional");
          this.setFieldValueExt(ffdf.oriIndex, null);
        } else if (!find && currentAccess != "hidden") {
          this.setFieldAccessExt(ffdf.oriIndex, "hidden");
          this.setFieldValueExt(ffdf.oriIndex, null);
          this.reloadQuery();
        }
      });

      //this.updateAndRender();
    },

    blurFieldFilter() {
      this.showFieldFilter = false;
    },

    showFieldFilterSelect() {
      this.showFieldFilter = !this.showFieldFilter;
    },

    sourceActionConfirm() {
      return this.sourceAction && this.sourceAction.confirm;
    },

    skeletonContent() {
      return this.sourceActionConfirm()
        ? "text"
        : "table-heading, list-item-two-line, image, table-tfoot";
    },

    autoCloseEmbedTransactionOnSubmit(jumpScreen) {
      const okMethod = ["delete", "post", "put"].includes(
        this.transactionMethod
      );

      const okEmbedAction =
        this.embedded && this.sourceAction.inputAction != "keep";
      const okNotJump = !jumpScreen;

      return okMethod && okEmbedAction && okNotJump;
    },

    confirmChangesExit(data, embed) {
      const bulkContentAction = this.screen.actions.find((action) => {
        return action.type == "bulkContent";
      });
      const formCrudBehavior =
        this.formScreen(this.screen) &&
        this.crudScreen(this.screen) &&
        this.formAllReadOnly(this.screen) &&
        this.changeHappened;
      const queryBulkContentBehavior =
        this.queryScreen(this.screen) &&
        this.changeQueryHappened &&
        bulkContentAction;
      if (formCrudBehavior || queryBulkContentBehavior) {
        let buttons = [];
        let type = "";
        if (formCrudBehavior) {
          buttons = [
            {
              caption: this.translatedText("saveText"),
              value: "yes",
            },
            {
              caption: this.translatedText("dontSaveText"),
              value: "no",
            },
            {
              caption: this.translatedText("cancelText"),
              value: "cancel",
            },
          ];
          type = "changes-form";
        } else if (queryBulkContentBehavior) {
          const caption = this.translatedConfig(
            this.generalExApplicationEx,
            this.customLanguage,
            bulkContentAction,
            "caption"
          );
          const dontCaption = this.translatedText("dontText") + " " + caption;
          buttons = [
            { caption: caption, value: "yes" },
            { caption: dontCaption, value: "no" },
            {
              caption: this.translatedText("cancelText"),
              value: "cancel",
            },
          ];
          type = "changes-bulk-action";
        }
        this.submit.todo = true;
        this.showConfirm({
          content: this.translatedText("confirmChangesText"),
          type,
          data: { data, embed, action: bulkContentAction },
          buttons,
        });
        return true;
      } else {
        return false;
      }
    },

    initCloseTransaction(data, embed) {
      if (!this.confirmChangesExit(data, embed)) {
        this.endCloseTransaction(data, embed);
      }
    },

    initCloseAllTransaction(data, embed) {
      if (!this.confirmChangesExit(data, embed)) {
        this.endCloseAllTransaction(data, embed);
      }
    },

    endCloseTransaction(data, embed) {
      this.$emit("close-parent-flap", data, embed);
    },
    endCloseAllTransaction(data, embed) {
      this.$emit("close-parent-all-flap", data, embed);
    },

    queryFilterEnabled() {
      const queryCondition = this.queryScreen(this.screen) && this.queryLoaded;
      const calendarCondition =
        this.calendarScreen(this.screen) && this.calendarLoaded;
      const result =
        (queryCondition || calendarCondition) &&
        this.showFieldFilter &&
        this.formFilterDynamic;
      return result;
    },

    queryFilterButtonEnabled() {
      const queryCondition = this.queryScreen(this.screen) && this.queryLoaded;
      const calendarCondition =
        this.calendarScreen(this.screen) && this.calendarLoaded;
      const result =
        (queryCondition || calendarCondition) && this.formFilterDynamic;
      return result;
    },

    showTrace(input) {
      this.trace = input;
      this.trace.show = true;
    },

    closeTrace(input) {
      this.trace = input;
      this.trace.show = false;
    },

    refreshButtonEnabled() {
      const queryCondfition =
        this.queryScreen(this.screen) && (this.queryLoaded || this.queryError);
      const calendarCondition =
        this.calendarScreen(this.screen) && this.calendarLoaded;
      return queryCondfition || calendarCondition;
    },

    transactionPermission() {
      const actionPermission = this.sourceAction
        ? this.sourceAction.allow
        : null;
      const menuPermission = this.menu.permission;
      return actionPermission ? actionPermission : menuPermission;
    },

    actualFieldAccess(access) {
      return this.transactionPermission() == "readonly" && access != "hidden"
        ? "readonly"
        : access;
    },

    okShowTrace() {
      return (
        this.environment.endpoint.trace &&
        this.loadedTransaction &&
        this.trace.show
      );
    },

    queryMode() {
      return this.custom ? this.custom.queryMode : "INTERACTIVE";
    },

    userInteraction(args) {
      this.$emit("user-interaction", args);
    },

    addCatalogingList(catalogData) {
      const found = this.catalogingList.find((c) => c.key == catalogData.key);
      if (!found) {
        this.catalogingList.push(catalogData);
      }
    },

    deleteCatalogingList(key) {
      const found = this.catalogingList.findIndex((c) => c.key == key);
      if (found != null) {
        this.catalogingList.splice(found);
      }
    },

    addDictionaryingList(dictionaryData) {
      const found = this.dictionaryingList.find(
        (d) => d.dictionaryName == dictionaryData.dictionaryName
      );
      if (!found) {
        this.dictionaryingList.push(dictionaryData);
      }
    },

    deleteDictionaryingList(dictionaryName) {
      const found = this.dictionaryingList.findIndex(
        (d) => d.dictionaryName == dictionaryName
      );
      if (found != null) {
        this.dictionaryingList.splice(found);
      }
    },
  },

  updated() {},

  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
</style>
